import React, { useCallback, useRef } from "react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Dropdown,
  Form,
  Pagination,
  ProgressBar,
  Row,
  Spinner,
  Stack,
  Popover,
  OverlayTrigger,
  Overlay,
} from "react-bootstrap";
import _, { debounce, now } from "lodash";
import moment from "moment-timezone";
import {
  useTable,
  usePagination,
  useSortBy,
  useBlockLayout,
} from "react-table";
import { useSticky } from "react-table-sticky";
import styled from "styled-components";

import { HeaderList } from "../../components/HeaderList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSortAlphaUp,
  faSortAlphaDown,
  faSort,
  faCalendarCheck,
  faExclamationTriangle,
  faExclamationCircle,
  faBuildingCircleExclamation,
  faMoneyBill,
  faPlus,
  faPlusCircle,
  faBell,
  faWrench,
  faPlugCircleXmark,
  faUser,
  faUsers,
  faAngleDown,
  faAngleUp,
  faThumbsUp,
  faUserCheck,
  faMoneyBillTransfer,
  faMinus,
  faCirclePlus,
  faCoins,
  faAnglesLeft,
  faAnglesRight,

} from "@fortawesome/free-solid-svg-icons";
import ModalProgPickup from "../../components/ModalProgPickup";
import { ModalGeneralInformation } from "../../components/ModalGeneralInformation";
import { ModalGeneralCaption } from "../../components/ModalGeneralCaption";

import Badge from "react-bootstrap/Badge";
import { LocaleService } from "../../services/locale.service";
import { TransporterService } from "../../services/transporter.service";
import { ToastService } from "../../services/toast.service";
import { DatasetDefault, DatasetModel } from "../../models/dataset.model";
import { LocaleModel } from "../../models/locale.model";
import { TransporterModel } from "../../models/transporter.model";
import { BranchModel } from "../../models/branch.model";
import { AlertaModel } from "../../models/alert.model";
import { DashboardCoreModel } from "../../models/dashboardCore.model";
import { HeadDateModel } from "../../models/headDate.model";
import { BranchService } from "../../services/branch.service";
import { DashboardService } from "../../services/dashboard.service";
import { UserService } from "../../services/user.service";
import { EquipmentAcknowledgeService } from "../../services/equipmentacknowledge.service";
import { EquipmentAcknowledgeModel } from "../../models/equipmentAcknowledge.model"
import PickupStatusService from "../../services/pickupStatus.service";

import {
  RequestInputOutputParamsModel,
  RequestInputOutputParamsModelDefault,
} from "../../models/requestInputOutputParams.model";
import InfiniteScroll from "react-infinite-scroll-component";
import storageService from "../../services/storage.service";
import HelperService from "../../services/helper.service";
import Preloader from "../../components/Preloader";
import { ModalAlertList } from "../../components/ModalAlertList";
import { ModalEquipmentImpose } from "../../components/ModalEquipmentImpose";
import { ButtonClean, ButtonSearch } from "../../components/buttons";
import { ButtonInfo } from "../../components/buttons";
import { ButtonCaption } from "../../components/buttons";
import { ProgressBarLegend } from "../../components/progressBar";

import { DropdownButtonExport } from "../../components/dropdownButton";
import { FileExportService } from "../../services/fileExport.service";
import { ResultRequestModel } from "../../models/resultRequest.model";
import { relative } from "path";
import UtilService from "../../services/util.service";

import Accordion from "react-bootstrap/Accordion";
import ConfigService from "../../services/config.service";
import ButtonProgram from "../../components/buttons/program";


import MonitoringBar from "../../components/MonitoringBar"; /* MONITORAMENTO */
import EventExportService from "../../services/eventExport.service"; //Sprint 29 - Permitir exportar Equipamentos 
import { UserPreferenceService } from "../../services/userPreference.service";
import { CustomModal } from "../../components/Modal";
import ReactDOM from "react-dom";
import EquipmentConfigService from "../../services/equipmentConfig.service";
/*
     Sprint 34 - Remover no futuro
      Contador para controlar o modal, para habilitar ou desabilitar
     */
import { ConfigFeatureService } from "../../services/configFeature.service";
import Select from 'react-select';
import { MultiEquipmentGroupService } from "../../services/multiequipmentgroup.service";

import { MinimumValuePickupJustifyJustificationService } from "../../services/minimumvaluepickupjustifyjustification.service";

let isEqualToDayG = false;

const Styles = styled.div`

  .cell-selected {
    border-style: solid !important;
    border-width: 0.2rem !important;
    border-color: #830505 !important;
  }

  .table {
    th:first-child {
      box-shadow: 0px 0px 1px #fffff;
    }

    .th {
      color: #fff;
      overflow: hidden;
      :last-child {
        border-right: 0;
      }
      
    }

    .th[data-is-days="false"] {
      background-color: #4e4e4e; /* Cinza */
    }

    .th[data-is-days="true"] {
      background-color: var(--bs-primary);
    }

    ,
    .tr {
      background-color: #fff;
    }

    ,

    /* .tr:hover {
      background-color: #a9d18e;
    },   */
 

    .td {
      box-shadow: 0px 0px 1px #000000;
      overflow: hidden;
      text-align: center;
      :last-child {
        border-right: 0;
      }
    }

    .td[data-is-days="false"] {
      background-color: #d3d3d3; /* Cinza claro */
    }

    .td[data-is-days="true"] {
      background-color: #fff; /* Branco */
    }

    /* Hover com base no atributo da tr */

.tr:hover > .td {
  background-color: #a9d18e !important ;
}

    &.sticky {
      overflow: scroll;
      .header,
      .footer {
        position: sticky;
        z-index: 1;
        width: fit-content;
      }

      .header {
        top: 0;
        box-shadow: 0px 0px 1px #000000;
      }

      .footer {
        bottom: 0;
        box-shadow: 0px 0px 1px #000000;
      }

      .body {
        position: relative;
        z-index: 0;
      }

      [data-sticky-td] {
        position: sticky;
      }
      
      /* Sempre aplica estilos para a segunda coluna */
    /* Sempre aplica estilos para a segunda coluna */
[data-sticky-td]:nth-child(3) {
  position: sticky;
  border-left: 1px solid #fff;
}

/* Adicionar regras dinâmicas para showClientGroup e showBalanceGroup */
${(props) => {
    if (props.showClientGroup && props.showBalanceGroup) {
      return `
      [data-sticky-td]:nth-child(4) {
        position: sticky;
        border-right: 1px solid #fff;
      }
      [data-sticky-td]:nth-child(7) {
        position: sticky;
        border-right: 1px solid #fff;
      }
    `;
    }

    if (props.showClientGroup && !props.showBalanceGroup) {
      return `
      [data-sticky-td]:nth-child(4) {
        position: sticky;
        border-right: 1px solid #fff;
      }
    `;
    }

    if (!props.showClientGroup && props.showBalanceGroup) {
      return `
      [data-sticky-td]:nth-child(5) {
        position: sticky;
        border-right: 2px solid #fff;
      }
      
    `;
    }

    

    // Caso nenhum dos grupos esteja ativo, não aplica nenhuma regra
    if (!props.showClientGroup && !props.showBalanceGroup) {
      return `
      [data-sticky-td]:nth-child(3) {
        position: sticky;
        border-left: 0px solid #fff;
      }
    `;
    }
  }}
  }

      [data-sticky-last-left-td]:not:first-child {
        box-shadow: 0px 0px 0px #000;
      }

      [data-sticky-first-right-td] {
        box-shadow: 0px 0px 1px #000000;
      }

      .td {
        padding: 0rem 0rem 0rem 0rem;
      }
      .td {
        color: rgb(85, 85, 85);
        font-size: 0.85rem;
      }

      .vstack {
        align-self: center !important
      }

      .tgap {
        margin-top: -3px;
      }
    }
  }
`;

// ==== Linha otimizada e tipada ====
interface TableRowProps {
  row: any;
  prepareRow: (row: any) => void;
  isEqualToDayG: boolean;
}

// ==== Componente memoizado ====
const TableRow: React.FC<TableRowProps> = React.memo(
  ({ row, prepareRow, isEqualToDayG }) => {
    // corpo do componente
    prepareRow(row);
    return (
      <tr {...row.getRowProps()} className='tr'>
        {row.cells.map((cell: any) => (
          <div 
            {...cell.getCellProps()}
            className='td'
            data-is-days={isEqualToDayG ? "true" : "false"}
          >
            {cell.render("Cell")}
          </div>
        ))}
      </tr>
    );
  },

  // 🔹 Aqui vai a função de comparação de props:
  (prevProps, nextProps) => {
    return (
      prevProps.row.id === nextProps.row.id &&
      prevProps.isEqualToDayG === nextProps.isEqualToDayG &&
      prevProps.row.original === nextProps.row.original
    );
  }
);

// ==== Componente principal ====
function Table({ columns, data, hideFilter, update, total_records, msgEmpty, showClientGroup, showBalanceGroup }) {

  const alwaysHidden = React.useMemo(() => {
    const hidden: string[] = [];

    if (columns) {
      for (let i = 0; i < columns.length; i++) {
        const colFather = columns[i];

        if (colFather.columns) {
          for (let j = 0; j < colFather.columns.length; j++) {
            const colChild = colFather.columns[j];
            if (colChild.isVisible === false) hidden.push(colChild.id || colChild.accessor);
          }
        } else {
          if (colFather.isVisible === false) hidden.push(colFather.id || colFather.accessor);
        }
      }
    }

    return hidden;
  }, [columns]);

  const toggleHidden = React.useMemo(() => {
    const hidden: string[] = [];
    if (!showClientGroup) hidden.push("clientComercialName", "limitMonetary");
    if (!showBalanceGroup) hidden.push("limitContractual", "read_date_from_pickup", "balance");
    return hidden;
  }, [showClientGroup, showBalanceGroup]);

  const hiddenColumns = React.useMemo(() => {
    // junta e remove duplicados
    return Array.from(new Set([...alwaysHidden, ...toggleHidden]));
  }, [alwaysHidden, toggleHidden]);

  const defaultColumn = React.useMemo(() => ({}), []);
  const [filterHeight, setFilterHeight] = useState(40);

  React.useEffect(() => {
    const refFilter = document.getElementById("filterRefId");
    if (refFilter) setFilterHeight(refFilter.clientHeight);
  }, [hideFilter]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      initialState: {
        hiddenColumns: hiddenColumns, // 👈 AQUI você controla o que fica escondido
      },
      disableSortBy: true,
    },
    useBlockLayout,
    useSticky,
    useSortBy,
    usePagination
  );

  // ✅ mantém seu memo do header
  const headerGroupsMemo = React.useMemo(() => headerGroups, [headerGroups]);

  return (
    <>
      <Styles showClientGroup={showClientGroup} showBalanceGroup={showBalanceGroup}>
        <InfiniteScroll
          dataLength={rows.length}
          next={update}
          hasMore={rows.length !== (total_records || 0)}
          loader={<></>}
          scrollableTarget='scrollableDiv'
        >
          <div
            {...getTableProps()}
            id='scrollableDiv'
            className='table sticky'
            style={{
              width: "99%",
              paddingLeft: "15px",
              minHeight: 450 - filterHeight,
              height: "calc(100vh - " + (240 + filterHeight) + "px)",
              overflow: "auto",
            }}
          >
            {/* ===== Cabeçalho ===== */}
            <div className='header'>
              {headerGroupsMemo.map((headerGroup: any) => (
                <th {...headerGroup.getHeaderGroupProps()} className='tr'>
                  {headerGroup.headers.map((column: any) => (
                    <div
                      {...column.getHeaderProps()}
                      className='th'
                      data-is-days={isEqualToDayG ? "true" : "false"}
                    >
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ display: "table-caption" }}>
                          {column.render("Header")}
                        </div>
                        {column.canSort ? (
                          column.isSorted ? (
                            <FontAwesomeIcon
                              icon={
                                column.isSortedDesc
                                  ? faSortAlphaDown
                                  : faSortAlphaUp
                              }
                            />
                          ) : (
                            <FontAwesomeIcon icon={faSort} />
                          )
                        ) : null}
                      </div>
                    </div>
                  ))}
                </th>
              ))}
            </div>

            {/* ===== Corpo otimizado ===== */}
            <div {...getTableBodyProps()} className='body'>
              {rows.map((row: any) => (
                <TableRow
                  key={`${row.id}-${showClientGroup}-${showBalanceGroup}`}
                  row={row}
                  prepareRow={prepareRow}
                  isEqualToDayG={isEqualToDayG}
                />                
              ))}
            </div>
          </div>
        </InfiniteScroll>
      </Styles>
    </>
  );
}

// 🔹 Exporta memoizado — re-renderiza apenas quando as props mudam
export default React.memo(Table);


export const HomeList = () => {
  const { t } = useTranslation();
  const idiom = storageService.getIdiom();
  const [isLoading, setLoading] = useState(false);
  const [selectedDataDashboard, setSelectedDataDashboard] = useState(null);
  const selectedDataDashboardRef = useRef<any[]>([]);
  const [headDate, setHeadDate] = useState<HeadDateModel>();
  const [cacheDate, setCacheDate] = useState(null);
  /* MONITORAMENTO */
  const [monitoringData, setMonitoringData] = useState([]);
  const [monitoringDataNewSelected, setMonitoringDataNewSelected] = useState(false);
  // Tipando o estado de percentageBalanceOnline como OptionType ou null
  const [percentageBalanceOnline, setPercentageBalanceOnline] = useState<number | null>(null);

  // Definindo as opções de porcentagem
  const percentageOptions = [
    { value: 50, label: "50%" },
    { value: 60, label: "60%" },
    { value: 70, label: "70%" },
    { value: 80, label: "80%" },
    { value: 90, label: "90%" },
    { value: 100, label: "100%" }
  ];

  // Recupera o estado salvo no localStorage ou define como true se não existir
  const [showClientGroup, setShowClientGroup] = useState(() => {
    const storedValue = localStorage.getItem("showClientGroup");
    return storedValue ? JSON.parse(storedValue) : true; // Converte string para booleano
  });

  const [showBalanceGroup, setShowBalanceGroup] = useState(() => {
    const storedValue = localStorage.getItem("showBalanceGroup");
    return storedValue ? JSON.parse(storedValue) : true;
  });

  // Atualiza o localStorage quando showClientGroup mudar
  useEffect(() => {
    localStorage.setItem("showClientGroup", JSON.stringify(showClientGroup));
  }, [showClientGroup]);

  // Atualiza o localStorage quando showBalanceGroup mudar
  useEffect(() => {
    localStorage.setItem("showBalanceGroup", JSON.stringify(showBalanceGroup));
  }, [showBalanceGroup]);

  const toggleClientGroup = () => setShowClientGroup((prev) => !prev);
  const toggleBalanceGroup = () => setShowBalanceGroup((prev) => !prev);

  const [datasetDashboardCore, setDatasetDashboardCore] =
    useState<DatasetModel>({
      ...JSON.parse(JSON.stringify(DatasetDefault)),
      dataset: "dashboard_core",
      filters: {
        locale_id: [],
        transporter_id: [],
        branch_id: [],
        is_pickup: null,
        is_event: null,
        is_danger: null,
        code_equipment: [],
        customer: [],
        multiclient: [],
        monit_equipment: [],
        equipment_imposition: [],
        percentage_balance_online: null, // Adicionando a variável de porcentagem
        history_date_filter: [],
      },
      sort: {
        field: "code_equipment",
        orientation: "asc",
      },
    });

  const data = React.useMemo(
    () => datasetDashboardCore?.data || [],
    [headDate, datasetDashboardCore?.data, selectedDataDashboard]
  );
  const [defaultTotalRecords, setDefaultTotalRecords] = useState(25);
  const [recordsPages, setRecordsPages] = useState(defaultTotalRecords);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showModalGeneralInformation, setModalGeneralInformation] = useState(false);
  const [showModalGeneralCaption, setModalGeneralCaption] = useState(false);
  const [showIsDangerModal, setShowIsDangerModal] = useState({
    open: false,
    item: null,
    dayColumn: null,
    forced: null,
  });
  const [locales, setLocales] = useState<LocaleModel[]>();
  const [transporters, setTransporters] = useState<TransporterModel[]>();
  const [branches, setBranches] = useState<BranchModel[]>();
  const [showEquipmentsPickupInPeriod, setShowEquipmentsPickupInPeriod] =
    useState<boolean>(false);
  const [showEquipmentsEventsInPeriod, setShowEquipmentsEventsInPeriod] =
    useState<boolean>(false);
  const [addressClassifiedAsRisk, setAddressClassifiedAsRisk] =
    useState<boolean>(false);
  //const [showIndicators, setShowIndicators] = useState<boolean>(true);
  const user = storageService.getUser();
  const [desactiveProgramConfig, setDesactiveProgramConfig] = useState(true);

  const [enableRecentPickupAlert, setEnableRecentPickupAlert] = useState(false);

  const [modalAlertListShow, setModalAlertListShow] = useState(false);
  const [modalEquipmentImposeShow, setModalEquipmentImposeShow] = useState(false);

  const [isEqualTo8DaysAgo, setIsEqualTo8DaysAgo] = useState(false);
  const [isEqualToDay, setIsEqualToDay] = useState(false);

  const [selectedEquipmentsForAssociationitems, setSelectedEquipmentsForAssociationitems] = useState([]);

  const [pickupJustifyJustificationList, setpickupJustifyJustificationList] = useState([]);

    const columns = React.useMemo(
    () => [
      {
        Header: t("DASHBOARD.EQUIPMENT_DATA"),
        sticky: "left",
        columns: [
          {
            Header: "idEquipment",
            accessor: "idEquipment",
            isVisible: false,
          },
          {
            Header: (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: '28px' }}>
                <span>{t("DASHBOARD.EQUIPMENT")}</span>
              </div>
            ),
            accessor: "codeEquipment",
            Cell: (cellInfo) => columnCodeEquipment(cellInfo),
            minWidth: 100,
            maxWidth: 100,
            disableSortBy: true,
          },
          {
            Header: (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: '28px' }}>
                <span>{t("DASHBOARD.BRANCH")}</span>
              </div>
            ),
            accessor: "branchFullname",
            Cell: (cellInfo) => columnBranchName(cellInfo),
            minWidth: 65,
            maxWidth: 65,
            disableSortBy: true,
          },
          ...(showClientGroup
            ? [
              {
                Header: (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowClientGroup(false);
                      }}
                      style={{
                        position: "absolute",
                        top: "4px",
                        left: "-18px",
                        backgroundColor: "transparent", // ✅ fundo transparente
                        color: "#fff",
                        border: "none",          // ✅ remove qualquer borda
                        outline: "none",         // ✅ remove borda ao focar (acessibilidade visual)
                        width: "16px",
                        height: "16px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        padding: 0               // opcional: evita espaçamento interno padrão
                      }}
                    >
                      <FontAwesomeIcon icon={faAnglesLeft} />
                    </button>
                    <span
                      style={{
                        marginTop: "30px", // Espaço abaixo do ícone
                        color: "#fff",
                      }}
                    >
                      {t("DASHBOARD.COMERCIAL_CLIENT")}
                    </span>
                  </div>
                ),
                accessor: "clientComercialName",
                Cell: (props) => columnClienteComercialName(props.value),
                minWidth: 120,
                maxWidth: 120,
                headerClassName: "group-header", // Aplica borda ao grupo

              },
              {
                Header: (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      marginTop: "28px",
                    }}
                  >
                    <span>{t("DASHBOARD.IDEAL COLLECTION")}</span>
                  </div>
                ),
                accessor: "limitMonetary",
                Cell: (props) => formatColumnsCollectIdeal(props),
                minWidth: 90,
                maxWidth: 90,
              },
            ]
            : []),
          ...(showBalanceGroup
            ? [
              {
                Header: (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",

                    }}
                  >
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowBalanceGroup(false);
                      }}
                      style={{
                        position: "absolute",
                        top: "4px",
                        left: "-18px",
                        backgroundColor: "transparent", // ✅ fundo transparente
                        color: "#fff",
                        border: "none",          // ✅ remove qualquer borda
                        outline: "none",         // ✅ remove borda ao focar (acessibilidade visual)
                        width: "16px",
                        height: "16px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        padding: 0               // opcional: evita espaçamento interno padrão
                      }}
                    >
                      <FontAwesomeIcon icon={faAnglesLeft} />
                    </button>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Popover>
                          <Popover.Body>{t("DASHBOARD.LIMIT_CONTRACTUAL")}</Popover.Body>
                        </Popover>
                      }
                    >                   
                      <span
                        style={{
                          marginTop: "30px", // Espaço abaixo do ícone
                          color: "#fff",
                        }}
                      >
                        {t("DASHBOARD.LIMIT")}
                      </span>
                    </OverlayTrigger>                    
                  </div>
                ),
                accessor: "limitContractual",
                Cell: (props) => formatLimitContractual(props),
                minWidth: 100,
                maxWidth: 100,
              },
              {
                Header: (props) => (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      marginTop: "28px",
                    }}
                  >
                    <span>{t("DASHBOARD.LAST_PICKUP")}</span>
                  </div>
                ),
                accessor: "read_date_from_pickup",
                Cell: (props) => formatBalancePhysical(props),
                minWidth: 100,
                maxWidth: 100,
              },
              {
                Header: (props) => (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      marginTop: "28px",
                    }}
                  >
                    <span>{t("DASHBOARD.BALANCE")}</span>
                  </div>
                ),
                accessor: "balance",
                Cell: (props) => formatBalancePT(props),
                minWidth: 100,
                maxWidth: 100,
              },
            ]
            : []),
          {
            Header: (props) => (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "28px" }}>
                <span>{t("DASHBOARD.BALANCE_ONLINE_NAME")}</span>
              </div>
            ),
            accessor: "balanceOnline",
            Cell: (props) => formatBalanceOnline(props),
            minWidth: 100,
            maxWidth: 100,
          },
        ],
      },
      {
        Header: isEqualToDay ? t("DASHBOARD.DATES") : t("DASHBOARD.RETROACTIVE_DATA"),
        columns: [
          {
            Header: (props) => (
              <span style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "28px" }}>
                {renderWeekDayReadableDate(headDate?.d01Date)} <br />{" "}
                {renderWeekDayReadable(headDate?.d01Date)}
              </span>
            ),
            accessor: "d01Value",
            Cell: (cellInfo) => renderWeekday(cellInfo),
          },
          {
            Header: (props) => (
              <span style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "28px" }}>
                {renderWeekDayReadableDate(headDate?.d02Date)} <br />{" "}
                {renderWeekDayReadable(headDate?.d02Date)}
              </span>
            ),
            accessor: "d02Value",
            Cell: (cellInfo) => renderWeekday(cellInfo),
          },
          {
            Header: (props) => (
              <span style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "28px" }}>
                {renderWeekDayReadableDate(headDate?.d03Date)} <br />{" "}
                {renderWeekDayReadable(headDate?.d03Date)}
              </span>
            ),
            accessor: "d03Value",
            Cell: (cellInfo) => renderWeekday(cellInfo),
          },
          {
            Header: (props) => (
              <span style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "28px" }}>
                {renderWeekDayReadableDate(headDate?.d04Date)} <br />{" "}
                {renderWeekDayReadable(headDate?.d04Date)}
              </span>
            ),
            accessor: "d04Value",
            Cell: (cellInfo) => renderWeekday(cellInfo),
          },
          {
            Header: (props) => (
              <span style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "28px" }}>
                {renderWeekDayReadableDate(headDate?.d05Date)} <br />{" "}
                {renderWeekDayReadable(headDate?.d05Date)}
              </span>
            ),
            accessor: "d05Value",
            Cell: (cellInfo) => renderWeekday(cellInfo),
          },
          {
            Header: (props) => (
              <span style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "28px" }}>
                {renderWeekDayReadableDate(headDate?.d06Date)} <br />{" "}
                {renderWeekDayReadable(headDate?.d06Date)}
              </span>
            ),
            accessor: "d06Value",
            Cell: (cellInfo) => renderWeekday(cellInfo),
          },
          {
            Header: (props) => (
              <span style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "28px" }}>
                {renderWeekDayReadableDate(headDate?.d07Date)} <br />{" "}
                {renderWeekDayReadable(headDate?.d07Date)}
              </span>
            ),
            accessor: "d07Value",
            Cell: (cellInfo) => renderWeekday(cellInfo),
          },
          { Header: "d01Border", accessor: "d01Border", isVisible: false },
          { Header: "d01Danger", accessor: "d01Danger", isVisible: false },
          { Header: "d01Forced", accessor: "d01Forced", isVisible: false },

          { Header: "d02Border", accessor: "d02Border", isVisible: false },
          { Header: "d02Danger", accessor: "d02Danger", isVisible: false },
          { Header: "d02Forced", accessor: "d02Forced", isVisible: false },

          { Header: "d03Border", accessor: "d03Border", isVisible: false },
          { Header: "d03Danger", accessor: "d03Danger", isVisible: false },
          { Header: "d03Forced", accessor: "d03Forced", isVisible: false },

          { Header: "d04Border", accessor: "d04Border", isVisible: false },
          { Header: "d04Danger", accessor: "d04Danger", isVisible: false },
          { Header: "d04Forced", accessor: "d04Forced", isVisible: false },

          { Header: "d05Border", accessor: "d05Border", isVisible: false },
          { Header: "d05Danger", accessor: "d05Danger", isVisible: false },
          { Header: "d05Forced", accessor: "d05Forced", isVisible: false },

          { Header: "d06Border", accessor: "d06Border", isVisible: false },
          { Header: "d06Danger", accessor: "d06Danger", isVisible: false },
          { Header: "d06Forced", accessor: "d06Forced", isVisible: false },

          { Header: "d07Border", accessor: "d07Border", isVisible: false },
          { Header: "d07Danger", accessor: "d07Danger", isVisible: false },
          { Header: "d07Forced", accessor: "d07Forced", isVisible: false },
        ],
      },
    ],
    [headDate, datasetDashboardCore?.data, t, showClientGroup, showBalanceGroup,]
  );




  const renderWeekDayReadableDate = (value) => {
    if (value) {
      return UtilService.formatDate(moment(value), null);
    }
    return value;
  };

  const renderReducedWeekDayReadableTime = (value) => {
    if (value) {
      let formatDateTime = user.locale?.formatDateTime;
      formatDateTime = formatDateTime.replace("yyyy", "YY");
      formatDateTime = formatDateTime.replace(":ss", "");
      let timezone = user.locale?.timeZone.replace("UTC", "");
      let dateValue = value;

      let date = moment
        .utc(dateValue)
        // .utcOffset(parseInt(timezone))
        .format(formatDateTime)
        .split(" ");

      return (
        <>
          {date && (
            <>
              {date[0]} {date[1]}
            </>
          )}
        </>
      );
    }
  };

  const renderWeekDayReadable = (value) => {
    if (value) {
      let formatDate = user.locale?.formatDate;
      return t(`${moment(value).format("dddd").toUpperCase()}_NICK`);
    }
    return value;
  };

  const sendSelectedDay = async () => {
    setLoading(true);
    // Inicializa os contadores
    let equipmentMinimumForApproval = 0;  // Equipamentos mínimos para aprovação
    let equipmentWithDirectProgramming = 0;  // Equipamentos com programação direta

    // Copia selectedDataDashboard para não modificar o estado diretamente
    const updatedData = selectedDataDashboardRef.current.map(dataItem => {

      // Extrai a data de pickup_date para comparação
      const pickupDateItem = new Date(dataItem.pickup_date).toISOString().split('T')[0];

      // Encontra a correspondência em equipmentInfoArray com base nas condições fornecidas
      const matchingInfo = equipmentInfoArray.find(info => {
        const pickupDateInfo = new Date(info.pickup_date).toISOString().split('T')[0];
        return info.code_equipment === dataItem.code_equipment &&
          pickupDateInfo === pickupDateItem &&
          info.day_name === dataItem.day_name;
      });
      //console.log("matching Info " + JSON.stringify(matchingInfo));
      // Se encontrar correspondência, adiciona apenas os valores necessários ao item
      if (matchingInfo) {
        return {
          ...dataItem,
          contractual_limit_value: matchingInfo.contractual_limit_value,
          selected_collection_percentage: matchingInfo.selected_collection_percentage,
          justification: matchingInfo.justification,
          is_checked_prog_status: matchingInfo.is_checked_prog_status,
          is_programming_approved: matchingInfo.is_programming_approved,
          daysOfWeek: matchingInfo.day_of_week,
          decision_programming: matchingInfo.decision_programming,
          selected_collection_percentage_physical: matchingInfo.selected_collection_percentage_physical,
          dayNamePhysicalValue: matchingInfo.dayNamePhysicalValue,
          contractual_limit_physical_value: matchingInfo.contractual_limit_physical_value,
          // Indica que a coleta está abaixo do valor mínimo, mas não exige justificativa, 
          // pois foi sugerida automaticamente pelo sistema devido a restrições no dia ideal (sugestão rosa).          
          pickupunderminsyssuggestednojustification:matchingInfo.pickupunderminsyssuggestednojustification
        };
      }

      // Se não houver correspondência, define os campos como null
      return {
        ...dataItem,
        contractual_limit_value: null,
        selected_collection_percentage: null,
        justification: null,
        is_programming_approved: true,
        daysOfWeek: null,
        decision_programming: true,
        selected_collection_percentage_physical: null,
        dayNamePhysicalValue: null,
        contractual_limit_physical_value: null,
        // Indica que a coleta está abaixo do valor mínimo, mas não exige justificativa, 
        // pois foi sugerida automaticamente pelo sistema devido a restrições no dia ideal (sugestão rosa).        
        pickupunderminsyssuggestednojustification: false
      };
    });

    // Agora vamos contar os equipamentos de acordo com os critérios definidos

    

    updatedData.forEach(dataItem => {

      const retconfigbranch = branches
        ?.find((entry: any) => entry.id === dataItem.branch_id)
        ?.branchEquipBelowMinForApproval;

      if (dataItem.selected_collection_percentage !== null && dataItem.is_checked_prog_status === true 
          && dataItem.pickupunderminsyssuggestednojustification !== true && retconfigbranch === true) {
        // Contar como equipamento mínimo para aprovação
        equipmentMinimumForApproval++;
      } else if (dataItem.selected_collection_percentage === null || dataItem.pickupunderminsyssuggestednojustification === true || retconfigbranch !== true) {
        // Contar como equipamento com programação direta
        equipmentWithDirectProgramming++;
      }
    });

    // Exibir as contagens no console
    //console.log("Equipamentos mínimos para aprovação: ", equipmentMinimumForApproval);
    //console.log("Equipamentos com programação direta: ", equipmentWithDirectProgramming);


    const dataSend = {
      datasets: [
        {
          dataset: "dashboard_core_pickup",
          data: updatedData
        },
      ],
      parameters: { date_begin: moment().format("yyyy-MM-DD") },
      };

    DashboardService.equipmentPickup(dataSend)
      .then((response: any) => {
        if (response && response.success) {
          let respData = _.last(
            _.filter(response.result.datasets, { dataset: "dashboard_core" })
          );
          //let dataActual = _.clone(datasetDashboardCore);
          let dataActual = _.cloneDeep(datasetDashboardCore);

          _.map(respData?.data, data => {
            let idxDataSended = _.findIndex(dataActual.data, {
              idEquipment: data.idEquipment,
            });
            dataActual.data[idxDataSended] = data;
          });
          selectedDataDashboardRef.current = [];
          setSelectedDataDashboard(null);
          document.querySelectorAll(".cell-selected").forEach(el => el.classList.remove("cell-selected"));
          //setDatasetDashboardCore(dataActual);
          setDatasetDashboardCore({ ...dataActual });
          handleCloseModal();
          setJustification('');
          // Limpar a justificativa ao fechar o modal
          handleJustificationChange('');
          // Regras de exibição de mensagens baseadas nas situações descritas:
          if (configValue) {
            // Situação 1: Equipamentos enviados para aprovação
            if (equipmentMinimumForApproval > 0 && equipmentWithDirectProgramming === 0) {
              ToastService.success(t('DASHBOARD.EQUIPMENTS_SENT_FOR_APPROVAL', { count: equipmentMinimumForApproval }));
            }

            // Situação 2: Existem equipamentos com programação e também para aprovação (unificar em um único toast com quebra de linha)
            if (equipmentMinimumForApproval > 0 && equipmentWithDirectProgramming > 0) {
              const totalAssociados = selectedEquipmentsForAssociationitems
                .reduce((total, item) => total + item.associated.length, 0);

              ToastService.success(
                <>
                  {t('DASHBOARD.EQUIPMENTS_SCHEDULED_SUCCESSFULLY', { count: equipmentWithDirectProgramming, vincount: totalAssociados })}<br />
                  {t('DASHBOARD.EQUIPMENTS_SENT_FOR_APPROVAL', { count: equipmentMinimumForApproval })}
                </>
              );
            }

            // Situação 3: Nenhum equipamento selecionado para aprovação
            if (equipmentMinimumForApproval === 0 && equipmentWithDirectProgramming === 0) {
              ToastService.error(t('DASHBOARD.NO_EQUIPMENTS_SENT_FOR_APPROVAL_PROGRAMMING'));
            }

            // Situação 4: Todos os equipamentos estão programados com sucesso
            if (equipmentMinimumForApproval === 0 && equipmentWithDirectProgramming > 0) {

              const totalAssociados = selectedEquipmentsForAssociationitems
              .reduce((total, item) => total + item.associated.length, 0);

              ToastService.success(t('DASHBOARD.EQUIPMENTS_SCHEDULED_SUCCESSFULLY', { count: equipmentWithDirectProgramming , vincount: totalAssociados}));
            }
          } else {
            // Caso o configValue seja falso
            ToastService.success(t("DASHBOARD.SCHEDULE_SUCCESS"));
          }
        }
      })
      .finally(() => {
        setLoading(false);
        handleCloseModal();
        setJustification('');
        // Limpar a justificativa ao fechar o modal
        handleJustificationChange('');
        selectedDataDashboardRef.current = [];
        setSelectedDataDashboard(null);
        document.querySelectorAll(".cell-selected").forEach(el => el.classList.remove("cell-selected"));
      });
  };


  const sendIsDanger = async (item: any, dayColumn: any, forced?: boolean) => {
    const dataSend = {
      datasets: [
        {
          dataset: "dashboard_core_pickup",
          data: [
            {
              id_equipment: item.idEquipment,
              code_equipment: item.codeEquipment,
              pickup_date: dayColumn.format("yyyy-MM-DD"),
              forced,
            },
          ],
        },
      ],
      parameters: { date_begin: moment().format("yyyy-MM-DD") },
    };

    DashboardService.equipmentPickup(dataSend).then((response: any) => {
      //console.log("Response: " + JSON.stringify(response));
      if (response && response.success) {
        let respData = _.last(
          _.filter(response.result.datasets, { dataset: "dashboard_core" })
        );
        //let dataActual = _.clone(datasetDashboardCore);
        let dataActual = _.cloneDeep(datasetDashboardCore);
        let dataSended = _.findIndex(dataActual.data, {
          idEquipment: respData.data[0].idEquipment,
        });
        dataActual.data[dataSended] = respData.data[0];
        //setDatasetDashboardCore(dataActual);
        setDatasetDashboardCore({ ...dataActual });
        handleCloseModal();
        ToastService.success(t("DASHBOARD.ISDANGER_SUCCESS"));
      }
    });
  };

  const selectDay = async (
    item: any,
    dayColumn: any,
    restrited: any,
    dayName: any
  ) => {

    if (item[`${dayName}PendingApproval`] === true) {
      ToastService.warn(t("LEGEND.COLLECTION_RESTRICTION_SCHEDULE"),null);
      return;
    }

    if (restrited === false) {
      let actualSelectedData: any[] = _.clone(selectedDataDashboardRef.current) || [];
      let idxToRemove = actualSelectedData.flat().findIndex(
      n => n.id_equipment === item.idEquipment &&
          n.pickup_date === dayColumn.format("yyyy-MM-DD")
    );

    if (idxToRemove !== -1) {
      // remove pelo índice encontrado
      actualSelectedData = actualSelectedData
        .flat()
        .filter((_, i) => i !== idxToRemove);
      } else {
        var total_amount_collect_pickup_physical_limit = 0;
        var total_amount_collect_pickup_monetary_limit = 0;
        var flag_pickup_physical_limit = false;
        var flag_pickup_monetary_limit = false;

        switch (dayName) {
          case "d01":
            flag_pickup_monetary_limit =
              item.d01FlagCollectPhysicalMonetary === 1 ||
                item.d01FlagCollectPhysicalMonetary === 3
                ? true
                : false;
            flag_pickup_physical_limit =
              item.d01FlagCollectPhysicalMonetary === 2 ||
                item.d01FlagCollectPhysicalMonetary === 3
                ? true
                : false;
            total_amount_collect_pickup_physical_limit = item.d01Value;
            total_amount_collect_pickup_monetary_limit = item.d01ValueBanknotes;
            break;
          case "d02":
            flag_pickup_monetary_limit =
              item.d02FlagCollectPhysicalMonetary === 1 ||
                item.d02FlagCollectPhysicalMonetary === 3
                ? true
                : false;
            flag_pickup_physical_limit =
              item.d02FlagCollectPhysicalMonetary === 2 ||
                item.d02FlagCollectPhysicalMonetary === 3
                ? true
                : false;
            total_amount_collect_pickup_physical_limit = item.d02Value;
            total_amount_collect_pickup_monetary_limit = item.d02ValueBanknotes;
            break;
          case "d03":
            flag_pickup_monetary_limit =
              item.d03FlagCollectPhysicalMonetary === 1 ||
                item.d03FlagCollectPhysicalMonetary === 3
                ? true
                : false;
            flag_pickup_physical_limit =
              item.d03FlagCollectPhysicalMonetary === 2 ||
                item.d03FlagCollectPhysicalMonetary === 3
                ? true
                : false;
            total_amount_collect_pickup_physical_limit = item.d03Value;
            total_amount_collect_pickup_monetary_limit = item.d03ValueBanknotes;
            break;
          case "d04":
            flag_pickup_monetary_limit =
              item.d04FlagCollectPhysicalMonetary === 1 ||
                item.d04FlagCollectPhysicalMonetary === 3
                ? true
                : false;
            flag_pickup_physical_limit =
              item.d04FlagCollectPhysicalMonetary === 2 ||
                item.d04FlagCollectPhysicalMonetary === 3
                ? true
                : false;
            total_amount_collect_pickup_physical_limit = item.d04Value;
            total_amount_collect_pickup_monetary_limit = item.d04ValueBanknotes;
            break;
          case "d05":
            flag_pickup_monetary_limit =
              item.d05FlagCollectPhysicalMonetary === 1 ||
                item.d05FlagCollectPhysicalMonetary === 3
                ? true
                : false;
            flag_pickup_physical_limit =
              item.d05FlagCollectPhysicalMonetary === 2 ||
                item.d05FlagCollectPhysicalMonetary === 3
                ? true
                : false;
            total_amount_collect_pickup_physical_limit = item.d05Value;
            total_amount_collect_pickup_monetary_limit = item.d05ValueBanknotes;
            break;
          case "d06":
            flag_pickup_monetary_limit =
              item.d06FlagCollectPhysicalMonetary === 1 ||
                item.d06FlagCollectPhysicalMonetary === 3
                ? true
                : false;
            flag_pickup_physical_limit =
              item.d06FlagCollectPhysicalMonetary === 2 ||
                item.d06FlagCollectPhysicalMonetary === 3
                ? true
                : false;
            total_amount_collect_pickup_physical_limit = item.d06Value;
            total_amount_collect_pickup_monetary_limit = item.d06ValueBanknotes;
            break;
          case "d07":
            flag_pickup_monetary_limit =
              item.d07FlagCollectPhysicalMonetary === 1 ||
                item.d07FlagCollectPhysicalMonetary === 3
                ? true
                : false;
            flag_pickup_physical_limit =
              item.d07FlagCollectPhysicalMonetary === 2 ||
                item.d07FlagCollectPhysicalMonetary === 3
                ? true
                : false;
            total_amount_collect_pickup_physical_limit = item.d07Value;
            total_amount_collect_pickup_monetary_limit = item.d07ValueBanknotes;
            break;
        }

        let flag_branchEquipBelowMinForApproval = false; // default false
        flag_branchEquipBelowMinForApproval = !!branches?.find( e => e.id === item.branchId && e.branchEquipBelowMinForApproval === true );

        actualSelectedData.push({
          id_equipment: item.idEquipment,
          code_equipment: item.codeEquipment,
          day_name: dayName,
          pickup_date: dayColumn.format("yyyy-MM-DD"),
          flag_pickup_physical_limit: flag_pickup_physical_limit,
          flag_pickup_monetary_limit: flag_pickup_monetary_limit,
          total_amount_collect_pickup_physical_limit:
          total_amount_collect_pickup_physical_limit,
          total_amount_collect_pickup_monetary_limit:
          total_amount_collect_pickup_monetary_limit,
          is_checked_prog_status: true,
          decision_programming: null,
          branch_id:item.branchId,
          flag_branchEquipBelowMinForApproval,
          flagRecentPickupAlert : item.flagRecentPickupAlert
        });
      }
      selectedDataDashboardRef.current = actualSelectedData;
      setSelectedDataDashboard(actualSelectedData);
    } else {
      ToastService.warn(t("LEGEND.COLLECTION_RESTRICTION"), null);
    }
  };

  useEffect(() => {

  }, [selectedDataDashboard]);

  const renderWeekday = (cellInfo: any) => {
    const limitMonetaryCell = cellInfo.row.allCells.find(x => x.column.id === "limitMonetary");
    const limitContractualCell = cellInfo.row.allCells.find(
      (x) => x.column.id === "limitContractual"
    );

    const percValue =
      limitContractualCell && Number(limitContractualCell.value) > 0
        ? (Number(cellInfo.value) / Number(limitContractualCell.value)) * 100
        : 0;
   /*  const variantValue =
    percValueMonetary > 85 ? "danger" : percValueMonetary > 60 ? "warning" : "success"; */

    const columnId = cellInfo.column.id;

    const dataCy = `${cellInfo.row.original.codeEquipment}-${columnId.replace("Value", "")}`;

    let dayName = "";
    let dayColumn = moment();
    var indexColumn = 1;

    switch (columnId) {
      case "d01Value":
        dayName = "d01";
        break;
      case "d02Value":
        dayName = "d02";
        break;
      case "d03Value":
        dayName = "d03";
        break;
      case "d04Value":
        dayName = "d04";
        break;
      case "d05Value":
        dayName = "d05";
        break;
      case "d06Value":
        dayName = "d06";
        break;
      case "d07Value":
        dayName = "d07";
        break;
    }
    if (headDate) {
      dayColumn = moment(headDate[dayName + "Date"]);
    }

    const idx = cellInfo.row.id;

    const isEvent = cellInfo.data[idx][`${dayName}Event`] || false;
    const weekDayDangerValue = cellInfo.data[idx][`${dayName}Danger`] || false;
    const weekDayForcedValue = cellInfo.data[idx][`${dayName}Forced`] || false;
    const weekDayImposedValue = cellInfo.data[idx][`${dayName}Imposed`] || false;
    const weekDayForcedCashChangeValue = cellInfo.data[idx][`${dayName}ForcedCashChange`] || false;
    const weekDayImposedCashChangeValue = cellInfo.data[idx][`${dayName}ImposedCashChange`] || false;
    const marker = cellInfo.data[idx][`${dayName}Border`] || "transparent";
    const isMarked = cellInfo.data[idx][`${dayName}Border`] || false;
    const foundItem = selectedDataDashboardRef.current.flat().find(
      item => item.id_equipment === cellInfo.data[idx]["idEquipment"] && item.pickup_date === dayColumn.format("yyyy-MM-DD")
    );
    const idxSelected = foundItem ? 0 : -1;

    const dayToImposition = cellInfo.data[idx]["days_to_imposition"]
    const dayToImpositionCashChange = cellInfo.data[idx]["days_to_imposition_cash_change_delivery"]

    const isUpdated = cellInfo.data[idx][`isUpdated`];
    const weekDayExceedValue = cellInfo.data[idx][`${dayName}Exceed`] || false;
    const restrited = cellInfo.data[idx][`${dayName}Restricted`] || false;

    const predictPickupsMonetaryLimit =
      cellInfo.data[idx]["predictPickupsMonetaryLimit"] || false;
    const predictPickupsPhysicalLimit =
      cellInfo.data[idx]["predictPickupsPhysicalLimit"] || false;

    const limitPercentBankNotes = cellInfo.data[idx]["onlineBalancePhysicalLimitPercentage"] || 95;

    const limitPhysical = cellInfo.data[idx]["limitPhysical"] || 0;
    const limitContractual = cellInfo.data[idx]["limitContractual"] || 0;
    const balance_banknotes_lastday = cellInfo.data[idx]["balance_banknotes_lastday"] || 0;

    const valueBanknotes = cellInfo.data[idx][`${dayName}ValueBanknotes`] || 0;
    const percValueMonetary = limitContractual && Number(limitContractual) > 0
    ? (Number(cellInfo.value) / Number(limitContractual)) * 100
    : 0;
    const variantValue =
    percValueMonetary > 85 ? "danger" : percValueMonetary > 60 ? "warning" : "success";
    
    const valuePercentBanknotes =
      limitPhysical && Number(limitPhysical) > 0
        ? (Number(valueBanknotes) / Number(limitPhysical)) * 100
        : 0;
    const variantBanknotes =
      valuePercentBanknotes > limitPercentBankNotes
        ? "danger"
        : valuePercentBanknotes > limitPercentBankNotes - 25
          ? "warning"
          : "success";

    // Determina o status de aprovação baseado no dayName
    const pendingApproval = cellInfo.data[idx][`${dayName}PendingApproval`] || false;

    let paddingTopPx = "4px";
    const cssCustom = `
    .table {
      --bs-table-hover-bg: #a9d18e !important;
    }import { ValueBooleanList } from './../../models/config.model';

    `;
    return (
      <>
        <style>{cssCustom}</style>
        {restrited && (
          <OverlayTrigger
            delay={{ show: 250, hide: 400 }}
            placement='top'
            overlay={
              <Popover id='popover-basic'>
                <Popover.Body>
                  <span style={{ fontWeight: "bold" }}>
                    {t("LEGEND.COLLECTION_RESTRICTION")}
                  </span>
                </Popover.Body>
              </Popover>
            }>
            <div
              data-cy={dataCy}
              style={isEqualToDayG ? {
                cursor: isUpdated ? "pointer" : "",
                borderStyle: "solid",
                borderWidth: "0.2rem",
                borderColor: idxSelected >= 0 ? "#830505" : "transparent",
                backgroundColor:
                  restrited == true ? "#dcdcdc" : isUpdated ? marker : "#fff",
                fontSize: "0.85rem",
                opacity: isUpdated ? 1 : 0.65,
                paddingTop: paddingTopPx,
              } : {
                cursor: "pointer",
                borderStyle: "solid",
                borderWidth: "0.2rem",
                borderColor: idxSelected >= 0 ? "#830505" : "transparent",
                backgroundColor: "#dcdcdc",
                fontSize: "0.85rem",
                opacity: 1,
                paddingTop: paddingTopPx,
              }}
              onClick={() => {
                if (isUpdated) {
                  selectDay(
                    cellInfo.row.original,
                    dayColumn,
                    restrited,
                    dayName
                  );
                }
              }}>
              {isUpdated && (
                <>
                  <div
                    style={{
                      fontWeight: "bold",
                      color: "#0039A6",
                      display: "flex",
                      alignItems: "center",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        alignItems: "flex-end",
                        padding: 0,
                      }}>
                      <Row className="m-0">
                        <Stack
                          direction='horizontal'
                          gap={1}
                          className='mt-2 md-2'>
                          {/* Mostra o ícone faUserCheck se PendingApproval for true */}
                          {pendingApproval && (
                            <FontAwesomeIcon
                              title={t("DASHBOARD.APPROVAL_STATUS")}
                              style={{ color: "black" }}
                              icon={faUserCheck}
                              className="mb-1"
                            />
                          )}

                          {(weekDayImposedValue || weekDayForcedValue) && <FontAwesomeIcon
                            title={t("DASHBOARD.IMPOSITION")}
                            style={{
                              color: "red",
                            }}
                            icon={faExclamationTriangle}
                            className={`mb-1 ${isMarked ? "btnForced" : ""}`}
                          />}
                          {(weekDayImposedCashChangeValue || weekDayForcedCashChangeValue) && <FontAwesomeIcon
                            title={t("DASHBOARD.IMPOSITION")}
                            style={{
                              color: "#FFC107",
                            }}
                            icon={faExclamationTriangle}
                            className={`mb-1 ${isMarked ? "btnForced" : ""}`}
                          />}
                          {isEvent && (
                            <FontAwesomeIcon
                              title={t("DASHBOARD.EVENT")}
                              icon={faCalendarCheck}
                              className='mb-1'
                              style={{ marginRight: 2 }}
                            />
                          )}
                          {!weekDayImposedValue && !isEvent && (
                            <div className="tgap">&nbsp;</div>
                          )}
                          {/* 
                          {weekDayDangerValue &&
                            <FontAwesomeIcon
                              title={`${t('DASHBOARD.DANGER')}`}
                              icon={faExclamationTriangle}
                              className="mb-1" />
                          } */}

                          {/* {weekDayExceedValue &&
                            <FontAwesomeIcon
                              title={`${t('DASHBOARD.EXCEED')}`}
                              icon={faBuildingCircleExclamation}
                              className="mb-1" />
                          } */}
                        </Stack>
                      </Row>
                    </div>
                  </div>

                  <ProgressBarLegend
                    predict_pickups_monetary_limit={predictPickupsMonetaryLimit}
                    percValueMonetary={percValueMonetary}
                    variantValueMonetary={variantValue}
                    cellInfoMonetary={cellInfo.value}
                    predict_pickups_physical_limit={predictPickupsPhysicalLimit}
                    valueBanknotes={valueBanknotes}
                    valuePercentBanknotes={valuePercentBanknotes}
                    variantBanknotes={variantBanknotes}
                    columnId={columnId}
                  />
                </>
              )}

              {!isUpdated && <>-</>}
            </div>
          </OverlayTrigger>
        )}

        {!restrited && (
          <div
            data-cy={dataCy}
            style={isEqualToDayG ? {
              cursor: isUpdated ? "pointer" : "",
              borderStyle: "solid",
              borderWidth: "0.2rem",
              borderColor: idxSelected >= 0 ? "#830505" : "transparent",
              backgroundColor:
                restrited == true ? "#dcdcdc" : isUpdated ? marker : "#fff",
              fontSize: "0.85rem",
              opacity: isUpdated ? 1 : 0.65,
              paddingTop: paddingTopPx,
            } : {
              cursor: "pointer",
              borderStyle: "solid",
              borderWidth: "0.2rem",
              borderColor: idxSelected >= 0 ? "transparent" : "transparent",
              backgroundColor:
              restrited == true ? "#dcdcdc" : !isUpdated ? marker : marker,
              fontSize: "0.85rem",
              opacity: isUpdated ? 1 : 0.65,
              paddingTop: paddingTopPx,
            }}
            onClick={(e) => {
              if (!isUpdated) return;
              const cell = e.currentTarget;
              selectDay(cellInfo.row.original, dayColumn, restrited, dayName);
              // Alterna a classe diretamente no DOM
              if (cell.classList.contains("cell-selected")) {
                cell.classList.remove("cell-selected");
              } else {
                cell.classList.add("cell-selected");
              }
            }}>
            {isUpdated && (
              <>
                <div
                  style={{
                    fontWeight: "bold",
                    color: "#0039A6",
                    display: "flex",
                    alignItems: "center",
                  }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      alignItems: "flex-end",
                      padding: 0,
                    }}>
                    <Row className='m-0'>
                      <Stack
                        direction='horizontal'
                        gap={1}
                        className='mt-2 md-2'>
                        {/* Mostra o ícone faUserCheck se PendingApproval for true */}
                        {pendingApproval && (
                          <FontAwesomeIcon
                            title={t("DASHBOARD.APPROVAL_STATUS")}
                            style={{ color: "black" }}
                            icon={faUserCheck}
                            className="mb-1"
                          />
                        )}
                        {/*Triangulo que mostra o icone de imposição */}
                        {(weekDayImposedValue || weekDayForcedValue) && <FontAwesomeIcon
                          title={`${t("DASHBOARD.IMPOSITION")} (${dayToImposition} ${t("DASHBOARD.DAYS")})`}
                          style={{
                            color: "red",
                          }}
                          icon={faExclamationTriangle}
                          className={`mb-1 ${isMarked ? "btnForced" : ""}`}
                        />}

                        {(weekDayImposedCashChangeValue || weekDayForcedCashChangeValue) && <FontAwesomeIcon
                          title={`${t("DASHBOARD.IMPOSITION_CASH_CHANGE")} (${dayToImpositionCashChange} ${t("DASHBOARD.DAYS")})`}
                          style={{
                            color: "#FFC107",
                          }}
                          icon={faExclamationTriangle}
                          className={`mb-1 ${isMarked ? "btnForced" : ""}`}
                          
                        />}


                        {isEvent && (
                          <FontAwesomeIcon
                            title={t("DASHBOARD.EVENT")}
                            icon={faCalendarCheck}
                            className='mb-1'
                            style={{ marginRight: 2 }}
                          />
                        )}


                        {!weekDayImposedValue && !isEvent && !weekDayImposedCashChangeValue && !weekDayForcedCashChangeValue && !weekDayForcedValue && (
                          <div className="tgap">&nbsp;</div>
                        )}


                        {/* 
                        {weekDayDangerValue &&
                          <FontAwesomeIcon
                            title={`${t('DASHBOARD.DANGER')}`}
                            icon={faExclamationTriangle}
                            className="mb-1" />
                        }

                        {weekDayExceedValue &&
                          <FontAwesomeIcon
                            title={`${t('DASHBOARD.EXCEED')}`}
                            icon={faBuildingCircleExclamation}
                            className="mb-1" />
                        } */}
                      </Stack>
                    </Row>
                  </div>
                </div>

                <ProgressBarLegend
                  predict_pickups_monetary_limit={predictPickupsMonetaryLimit}
                  percValueMonetary={percValueMonetary}
                  variantValueMonetary={variantValue}
                  cellInfoMonetary={cellInfo.value}
                  predict_pickups_physical_limit={predictPickupsPhysicalLimit}
                  valueBanknotes={valueBanknotes}
                  valuePercentBanknotes={valuePercentBanknotes}
                  variantBanknotes={variantBanknotes}
                  columnId={columnId}
                />
              </>
            )}

            {!isUpdated && <>-</>}
          </div>
        )}
      </>
    );
  };

  const columnCodeEquipment = (cellInfo: any) => {
    const idx = cellInfo.row.id;
    const codeEquipament = cellInfo.data[idx]["codeEquipment"] || 0;
    const flagMultiClient = cellInfo.data[idx]["flagMultiClient"];

    const id_problem = cellInfo.data[idx]["id_problem"]
    const problem_description = cellInfo.data[idx]["problem_description"]

    const equipment_status_id = cellInfo.data[idx]["equipment_status_id"]
    const equipment_online_status_id = cellInfo.data[idx]["equipment_online_status_id"]
    const communication_date = cellInfo.data[idx]["communication_date"]

    return (
      <>
        <div
          style={{ height: "100%", display: "flex" }}
          className='align-middle'>
          <Stack gap={0}>
            {flagMultiClient && (
              <FontAwesomeIcon icon={faUsers} className='mb-1' />
            )}

            {(id_problem !== null && id_problem !== undefined) && (
              <FontAwesomeIcon
                title={id_problem + ' - ' + problem_description}
                style={{ color: "red" }}
                icon={faWrench}
                className='mb-1'
              />
            )}
            <span dangerouslySetInnerHTML={{ __html: codeEquipament }} />
            {(equipment_online_status_id !== null && equipment_online_status_id == 2 && equipment_online_status_id !== undefined) && (
              <div
                title={communication_date == null ? (t("DASHBOARD.COMMUNICATION_DATE_NULL_VALUE_RESP")) : (t("DASHBOARD.COMMUNICATION_DATE") + ': ' + moment(communication_date).format('DD/MM/YY HH:mm:ss'))}
                style={{ fontSize: "0.7rem", fontWeight: "bold", color: "#FF0000" }}>
                <FontAwesomeIcon
                  title={communication_date == null ? (t("DASHBOARD.COMMUNICATION_DATE_NULL_VALUE_RESP")) : (t("DASHBOARD.COMMUNICATION_DATE") + ': ' + moment(communication_date).format('DD/MM/YY HH:mm:ss'))}
                  style={{ color: "red" }}
                  icon={faPlugCircleXmark}
                  className='mt-1 fa-lg'
                />
              </div>
            )}

          </Stack>
        </div>
      </>
    );
  };

  const columnClienteComercialName = (cellInfo) => {
    let clienteComercialName = "";

    if (cellInfo != undefined) {
      clienteComercialName =
        cellInfo.length > 30 ? cellInfo.substring(0, 30) + "..." : cellInfo;
    }

    return (
      <OverlayTrigger
        placement='top'
        delay={{ show: 250, hide: 400 }}
        overlay={
          <Popover>
            <Popover.Body>{cellInfo}</Popover.Body>
          </Popover>
        }>
        <div
          style={{ height: "100%", display: "flex", alignSelf: "center", justifyContent: "center", flexDirection: "column", flex: "1 1 auto" }}
          dangerouslySetInnerHTML={{ __html: clienteComercialName }}
        />
      </OverlayTrigger>
    );
  };

  const columnBranchName = ({ value }) => {
    if (!value) return null; // Evita erro se não houver valor

    return (
        <div
            style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                flex: "1 1 auto",
                padding: "4px",
            }}
        >
            {value}
        </div>
    );
};



  const formatToCurrency = (value) => {
    let decimalSeparator = user.locale?.decimalSeparator;
    let thousandSeparator = user.locale?.thousandSeparator;
    let moneyPrefix = user.locale?.moneyPrefix;
    return HelperService.number_format_abbreviated(
      value,
      2,
      decimalSeparator,
      thousandSeparator
    );
  };


  const formatBalanceOnline = (cellInfo) => {
    const idx = cellInfo.row.id;

    const limitContractual = cellInfo.data[idx]["limitContractual"] || 0;
    const balanceOnline = cellInfo.data[idx]["balanceOnline"] || 0;

    //console.log("LimitContractual e balanceOnline: ", limitContractual, balanceOnline)

    const limitPhysical = cellInfo.data[idx]["limitPhysical"] || 0;
    const balanceOnlinePhysical = cellInfo.data[idx]["balanceOnlinePhysical"] || 0;

    //console.log("LimitContractualPhysical e balanceOnlinePhysical: ", limitPhysical, balanceOnlinePhysical)

    const onlineBalanceLimitPercentageColor = "#F55753";

    const onlineBalanceLimitPercentage =
      cellInfo.data[idx]["onlineBalanceLimitPercentage"] || 0;
    const balanceOnlineDate = cellInfo.data[idx]["balanceOnlineDate"];

    const onlineBalancePhysicalLimitPercentage =
      cellInfo.data[idx]["onlineBalancePhysicalLimitPercentage"] || 0;

    var percValueExceedValue = false;
    var variantValue = "";
    var variantValuePhysical = "";
    var background_color = "#ffffff00";

    let percValue =
      Number(limitContractual) !== 0
        ? (balanceOnline / limitContractual) * 100
        : 0;
    percValue = Math.round(percValue);

    let percValuePhysical =
      Number(limitPhysical) !== 0
        ? (balanceOnlinePhysical / limitPhysical) * 100
        : 0;
    percValuePhysical = Math.round(percValuePhysical);

    if (percValue >= 0 && percValue <= 50) {
      variantValue = "success";
    } else if (percValue >= 51 && percValue <= 80) {
      variantValue = "warning";
    } else if (percValue >= 81) {
      variantValue = "danger";
    }

    if (percValuePhysical >= 0 && percValuePhysical <= 50) {
      variantValuePhysical = "success";
    } else if (percValuePhysical >= 51 && percValuePhysical <= 80) {
      variantValuePhysical = "warning";
    } else if (percValuePhysical >= 81) {
      variantValuePhysical = "danger";
    }

    // Utilizando a lógica atual, para olhar o limite contratual, e não mais a porcentagem ideal
    if (balanceOnline >= limitContractual) {
      percValueExceedValue = true;
      background_color = onlineBalanceLimitPercentageColor;
    }

    if (balanceOnlinePhysical >= limitPhysical) {
      percValueExceedValue = true;
      background_color = onlineBalanceLimitPercentageColor;
    }

    let now = moment();
    let difNowBalance = moment(now).diff(balanceOnlineDate, "hour");
    let paddingTopPx = '12.5px';

    return (
      <>
        <div style={{
          backgroundColor: background_color, height: "100%",
          paddingTop: paddingTopPx
        }}>
          <span
            style={{
              color: percValueExceedValue ? "#fff" : "",
              fontWeight: percValueExceedValue ? "bold" : "",
              fontSize: cellInfo.value.toString().length > 12 ? "0.9em" : "1em"
            }}>

            {/* Reservando o espaço para o ícone, mesmo se ele não aparecer */}
            <div style={{ height: "14x", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "2px" }}>
              {difNowBalance > 12 ? (
                <FontAwesomeIcon
                  title={t("DASHBOARD.BALANCE_NOT_UPDATED")}
                  style={{ color: "red" }}
                  icon={faExclamationCircle}
                  className='mb-1'
                />
              ) : (
                <span style={{ visibility: "hidden", marginTop: "-1px" }}>🔴</span> // Espaço reservado
              )}
            </div>

            {formatToCurrency(cellInfo.value)} <br />
            <ProgressBar
              now={percValue}
              label={`${percValue.toFixed(0)}%`}
              variant={variantValue}
              style={{ marginTop: '4px', marginBottom: '4px' }}
            />

            <span
              style={{
                color: percValueExceedValue ? "#fff" : "",
                fontWeight: percValueExceedValue ? "bold" : "",
                fontSize: balanceOnlinePhysical.toString().length > 12 ? "0.9em" : "1em",
                paddingTop: '25pc',
              }}>
              {balanceOnlinePhysical} <br />
            </span>
          </span>

          <ProgressBar
            now={percValuePhysical}
            label={`${percValuePhysical.toFixed(0)}%`}
            variant={variantValuePhysical}
            style={{ marginTop: '0px', marginBottom: '-4px' }}
          />

          {balanceOnlineDate && (
            <span
              title={t("DASHBOARD.LAST_UPDATED")}
              style={{ fontSize: "0.65rem", fontWeight: "bold" }}>
              {renderReducedWeekDayReadableTime(balanceOnlineDate)}
            </span>
          )}
        </div>
      </>
    );
  };


/*   const formatBalancePT = (cellInfo) => {
    const idx = cellInfo.row.id;
    const balanceDate = cellInfo.data[idx]["balanceDate"];

    const physical_balance = cellInfo.data[idx]["balance_banknotes"];

    return (
      <div style={{ height: "100%", display: "flex" }}>
        <div style={{ height: "100%", display: "flex", alignSelf: "center", justifyContent: "center", flexDirection: "column", flex: "1 1 auto", paddingTop: '12px' }}>
          <span style={{ fontSize: cellInfo.value.toString().length > 12 ? "0.9em" : "1em", marginTop: '17px', marginBottom: "-9px" }}>
            {formatToCurrency(cellInfo.value)}
          </span>
          <span style={{ fontSize: cellInfo.value.toString().length > 12 ? "0.9em" : "1em", marginTop: '26px', marginBottom: "-19px" }}>
            {physical_balance}
          </span>
          {balanceDate && (
            <div
              title={t("DASHBOARD.LAST_UPDATED")}
              style={{ fontSize: "0.65rem", fontWeight: "bold", marginTop: "32px" }}>
              ({renderWeekDayReadableDate(balanceDate)})
            </div>
          )}
        </div>
      </div>
    );
  }; */

  const formatBalancePT = (cellInfo) => {
    const idx = cellInfo.row.id;
    const balanceDate = cellInfo.data[idx]["balanceDate"];
    const physical_balance = cellInfo.data[idx]["balance_banknotes"];
    const fontSize = cellInfo.value.toString().length > 12 ? "0.9em" : "1em";
  
    return (
      <div style={{ 
        height: "100%", 
        display: "grid", 
        gridTemplateRows: "1fr 1fr auto", 
        alignItems: "center", 
        justifyItems: "center", 
        padding: "6px 0"
      }}>
        <span style={{ fontSize, marginTop: '24px' }}>{formatToCurrency(cellInfo.value)}</span>
        <span style={{ fontSize, marginTop: '5px' }}>{physical_balance}</span>
        {balanceDate && (
          <div
            title="Última atualização"
            style={{
              fontSize: "0.65rem",
              fontWeight: "bold",
              textAlign: "center",
              marginTop: "0px"
            }}
          >
            ({renderWeekDayReadableDate(balanceDate)})
          </div>
        )}
      </div>
    );
  };
  

  const formatColumnsCollectIdeal = (cellInfo) => {
    const idx = cellInfo.row.id;

    const limitMonetary = cellInfo.data[idx]["limitMonetary"] || 0;
    const limitContractual = cellInfo.data[idx]["limitContractual"] || 0;

    const onlineBalancePhysicalLimitPercentage = cellInfo.data[idx]["onlineBalancePhysicalLimitPercentage"] || 0;

    // Calcula os valores percentuais
    let percValue1 = Math.trunc(
      Number(limitContractual) !== 0
        ? (limitMonetary / limitContractual) * 100
        : 0
    );

    let percValue2 = onlineBalancePhysicalLimitPercentage; // Valor do parâmetro na equipment config

    // Define a cor de fundo
    var background_color = "#ffffff00";
    let paddingTopPx = "12px";

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "5px", paddingLeft: "12px", marginTop: "33px" }}>
        {/* Primeiro bloco - Monetário */}
        <OverlayTrigger
          placement="top"
          overlay={
            <Popover>
              <Popover.Body>{`${t("MONETARY")}`}</Popover.Body>
            </Popover>
          }
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              //paddingTop: "33px",
              cursor: "pointer"
            }}
          >
            <FontAwesomeIcon icon={faMoneyBill} className="m-0" />
            <span>{`${percValue1}%`}</span>
          </div>
        </OverlayTrigger>

        {/* Segundo bloco - Físico */}
        <OverlayTrigger
          placement="top"
          overlay={
            <Popover>
              <Popover.Body>{`${t("PHYSICAL")}`}</Popover.Body>
            </Popover>
          }
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              marginTop: "14px",
              cursor: "pointer"
            }}
          >
            <FontAwesomeIcon icon={faCoins} className="m-0" />
            <span>{`${percValue2}%`}</span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const formatLimitContractual = (cellInfo) => {
    const idx = cellInfo.row.id;


    const limitContractual = cellInfo.data[idx]["limitContractual"] || 0;
    const limitPhysical = cellInfo.data[idx]["limitPhysical"] || 0;

    const balanceOnlineDate = cellInfo.data[idx]["balanceOnlineDate"];

    var percValueExceedValue = false;
    var variantValue = "";
    var background_color = "#ffffff00";


    let now = moment();
    let difNowBalance = moment(now).diff(balanceOnlineDate, "hour");

    let paddingTopPx = "12px";

    return (
      <>
        <div style={{ backgroundColor: background_color, height: "100%", paddingTop: paddingTopPx }}>
          <br />
          <span style={{}}>
            <span>{formatToCurrency(limitContractual)}</span>
          </span>
          <br />
          <span
            style={{
              color: percValueExceedValue ? "#000" : "",
              fontWeight: percValueExceedValue ? "bold" : "",
              fontSize: limitPhysical.toString().length > 12 ? "0.9em" : "1em"
            }}>
            <br />
            {limitPhysical} <br />
          </span>

        </div>
      </>
    );

  }

  const formatBalancePhysical = ({ value }) => {
    if (!value) return null; // Evita erro se não houver valor

    return (
        <div
            style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                flex: "1 1 auto",
                padding: "4px",
            }}
        >
            {renderWeekDayReadableDate(value)}
        </div>
    );
};

  const deselectMonitoringOptions = () => {
    setMonitoringDataNewSelected(false)

    setMonitoringData((prevState) => prevState.map((item) => ({
      ...item,
      selected: false,
    })));
  }

  /* MONITORAMENTO */
  const handleClickMonitoring = (monitoringName) => {

    setMonitoringData((prevState) => prevState.map((item) => ({
      ...item,
      selected: item.monitoring_name === monitoringName ? !item.selected : false,
    })));

    setMonitoringDataNewSelected(true)

  };

  useEffect(() => {
    if (monitoringDataNewSelected) {
      handleSearch();
    }
    setMonitoringDataNewSelected(false)
  }, [monitoringData]);

  const getList = async (dataTable, datasetOverride = null) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = {
      ...RequestInputOutputParamsModelDefault,
      datasets: [{ ...(datasetOverride || datasetDashboardCore) }],
    };

    //MONITORAMENTO 
    const selectedMonitoring = monitoringData.find((item) => item.selected === true);
    if (selectedMonitoring) {
      const today = moment().format("YYYY-MM-DD");
      const selectedDate = moment().format("YYYY-MM-DD"); // ou outra data se for variável
      // Se um item com selected true foi encontrado
      // Atualiza requestParams.datasets
      requestParams.datasets[0].filters = {
        ...requestParams.datasets[0].filters,
        monit_equipment: selectedMonitoring.monitoring_name,
        history_date_filter: selectedDate === today ? [] : [selectedDate], // Atualiza para a data de hoje
      };

    } else {
      requestParams.datasets[0].filters = {
        ...requestParams.datasets[0].filters,
        monit_equipment: null,

      };
    }

    if (!requestParams.parameters) {
      requestParams.parameters = { date_begin: moment().format("yyyy-MM-DD") };
    }

    if (dataTable !== null && requestParams?.datasets) {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = dataTable.page_number;
      pagination.records_pages = dataTable.records_pages;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = DatasetDefault.pagination.page_number;
      pagination.records_pages = defaultTotalRecords;
    }
    requestParams.datasets[0].data = [];
    const response: any = await DashboardService.getList(requestParams);
    let dsModelDashboardCore: DatasetModel;
    let monitEquipmentValue = requestParams.datasets[0].filters.monit_equipment;

    if (response.success === true && response.result) {
      const dsModelHeadDates: DatasetModel = _.last(
        _.filter(response.result.datasets, { dataset: "head_dates" })
      );
      setHeadDate(dsModelHeadDates?.data[0]);
      dsModelDashboardCore = _.last(
        _.filter(response.result.datasets, { dataset: "dashboard_core" })
      );
      let cacheData = response.result.datasets.filter(x => x.dataset == "dashboard_core")[0].data;
      if (cacheData != null && cacheData.length > 0) {
        setCacheDate(renderReducedWeekDayReadableTime(cacheData[0].cacheDate));
      }
    }

    setLoading(false);

    return dsModelDashboardCore;
  };

  const getequipmentMonit = async () => {

    let requestParams: RequestInputOutputParamsModel = {
      ...RequestInputOutputParamsModelDefault,
      datasets: [{ ...datasetDashboardCore }],
    };

    requestParams.datasets[0].data = [];
    const response: any = await DashboardService.equipmentMonit(requestParams);

    let dsModelEquipmentMonitCore: any;

    if (response.success === true && response.result) {
      dsModelEquipmentMonitCore = _.filter(response.result.datasets, { dataset: "equipment_monit" })[0]?.data;
    }

    // Crie um mapa para facilitar a pesquisa dos dados existentes por "monitoring_name"
    const existingmonitoringDataMap = monitoringData.reduce((map, item) => {
      map[item.monitoring_name] = item;
      return map;
    }, {});

    // Atualize os valores de "equipment_quantity" no novo JSON
    const updatedMonitoringData = dsModelEquipmentMonitCore.map((newItem) => {
      const existingItem = existingmonitoringDataMap[newItem.monitoring_name];
      if (existingItem) {
        newItem.selected = existingItem.selected; // Mantenha o valor existente de "selected"
      }
      return newItem;
    });

    setMonitoringData(updatedMonitoringData);

  };

  const [alertList, setAlertList] = useState([]);
  const [equipmentImposeList, setEquipmentImposeList] = useState([]);
  //Sprint 29 - Permitir exportar Equipamentos 
  const [datasetDashboardAnalytical, setDatasetDashboardAnalytical] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'equipment',
    filters: {
      branch_id: [],
      group_id: [],
      exceeded_balance_deadline: [],
      validade_config_feature: [true],
      date_begin_end: [],
    },
    pagination: {
      page_number: 1,
      total_pages: 0,
      records_pages: 999,
      total_records: 0
    },
  });

  //Sprint 29 - Permitir exportar Equipamentos 
  const handleSearch = async () => {
    const records = defaultTotalRecords;
    setRecordsPages(records);
    selectedDataDashboardRef.current = [];
    setSelectedDataDashboard(null);
    document.querySelectorAll(".cell-selected").forEach(el => el.classList.remove("cell-selected"));
    
    const trimcodeequipment = datasetDashboardCore.filters.code_equipment?.[0]?.trim() || "";
    const trimcustomer = datasetDashboardCore.filters.customer?.[0]?.trim() || "";

    const cleanedDataset = {
      ...datasetDashboardCore,
      filters: {
        ...datasetDashboardCore.filters,
        code_equipment: [trimcodeequipment],
        customer: [trimcustomer],
      },
    };

    setDatasetDashboardCore(
      await getList(
                    { page_number: 1, records_pages: records }, // primeiro argumento
                      cleanedDataset                              // segundo argumento
                    )

    );

    if (!monitoringDataNewSelected) {
      await getequipmentMonit();
    }
  };

  const [flagClear, setFlagClear] = useState(false);

  useEffect(() => {
    if (flagClear) {
      setMonitoringDataNewSelected(false);
      handleSearch();
      setFlagClear(false);
    }
  }, [flagClear]);

  const [isEquipmentImpositionChecked, setIsEquipmentImpositionChecked] = useState(false);

  const handleClean = () => {
    // Clearing filters in datasetDashboardCore and related states
    // Resetar o estado de percentageBalanceOnline

    //document.querySelectorAll(".cell-selected").forEach(el => el.classList.remove("cell-selected"));

    setPercentageBalanceOnline(null);

    setDatasetDashboardCore({
      ...datasetDashboardCore,
      filters: {
        branch_id: [],
        code_equipment: [],
        customer: [],
        multiclient: [],
        equipment_imposition: [],
        monit_equipment: [],
        percentage_balance_online: null,
        history_date_filter: [],
      },
    });
    setIsEquipmentImpositionChecked(false);
    //console.log('is_equipment_imposition', isEquipmentImpositionChecked)
    setFlagClear(true);

    // Garantir que showClientGroup e showBalanceGroup sejam definidos como true
    setShowClientGroup(true);
    setShowBalanceGroup(true);
  };

  useEffect(() => {
    //console.log('is_equipment_imposition', isEquipmentImpositionChecked);
  }, [isEquipmentImpositionChecked]);

  const showGeneralInformation = async () => {
    setModalGeneralInformation(true);
  };

  const showGeneralCaption = async () => {
    setModalGeneralCaption(true);
  };

  const handleCloseModalAlertList = () => {
    setModalAlertListShow(false);
  };

  const handleCloseModalEquipmentImpose = () => {
    let list = equipmentImposeList.map(item => ({ "equipmentAcknowledgeTypeId": 1, "equipmentId": item.equipment_id, "firstImpositionDate": item.first_imposition_date, "daysWithoutCollection": item.days_since_last_collection, "branch": item.nickname, "equipmentCode": item.code_equipment, "processed": item.acknowledge_date != null }));
    EquipmentAcknowledgeService.sendAcknowledge(list.filter(x => !x.processed));
    setModalEquipmentImposeShow(false);
  };


  const fetchMoreData = async () => {
    if (isLoading ===false) 
    {
      const page = datasetDashboardCore.pagination.page_number + 1;
      let resp = await getList({
        page_number: page,
        records_pages: recordsPages,
      });
      let actualDatasetDashboardCore: DatasetModel =
        _.clone(datasetDashboardCore);
      actualDatasetDashboardCore.pagination = resp.pagination;
      actualDatasetDashboardCore.data = actualDatasetDashboardCore.data.concat(
        resp.data
      );
      setDatasetDashboardCore(actualDatasetDashboardCore);
    }
  };

// Busca no config a chave ENABLE_RECENT_PICKUP_ALERT e atualiza o estado
// indicando se o alerta de programação recente deve ser exibido.
const fetchRecentPickupAlertConfig = async () => {
  const response: any = await ConfigService.GetByKeyAndLocale(
    "ENABLE_RECENT_PICKUP_ALERT"
  );

  if (response && response.success && response.result) {
    setEnableRecentPickupAlert(response.result.configValue === "true");
  } else {
    setEnableRecentPickupAlert(false);
  }
};

  const fetchProgramEquipmentContingencyConfig = async () => {
    var response: any = await ConfigService.GetByKeyAndLocale(
      "PROGRAM_EQUIPMENT_CONTINGENCY"
    );
    if (response && response.success && response.result) {
      setDesactiveProgramConfig(response.result.configValue == "true");
    }
    else {
      setDesactiveProgramConfig(false);
    }

  };
  /**
   * Faz uma chamada a api para buscar valores de configurações do equipamento
   * as configuração são essencias para determinar se a coleta deve ser alertada e qual 
   * é o valor percentual mínimo aceitável para coleta.
   * ele é modificado, Dentro de um useEffect que é disparado quando showScheduleModal
   * é verdadeiro ou quando selectedEquipmentDataWithDays muda
   */
  const fetchConfigValue = async () => {
    var response: any = await ConfigService.GetByKeyAndLocale(
      "EQUIP_BELOW_MIN_FOR_APPROVAL"
    );
    if (response && response.success && response.result) {
      setConfigValue(response.result.configValue == "true");
    }
    else {
      setConfigValue(false);
    }
  };

  const [hideFilter, setHideFilter] = useState(false);
  const filterRef = useRef(null);
  const iconRef = useRef(null);
  const [collectionForecastColor, setCollectionForecastColor] = useState("");
  const [inPlanCollectionServiceColor, setInPlanCollectionServiceColor] =
    useState("");
  const [planedCollectionServiceColor, setPlanedCollectionServiceColor] =
    useState("");
  const [scheduledCollectionServiceColor, setScheduledCollectionServiceColor] =
    useState("");
  const [executedCollectionServiceColor, setExecutedCollectionServiceColor] =
    useState("");

  /*
  sprint 3100
  Este trecho de código utiliza o useEffect do React para verificar, 
  ao montar o componente, se há um valor armazenado no localStorage que controla
  a visibilidade do filtro do dashboard. Se houver, ele atualiza o estado 
  hideFilter com o valor recuperado.
  */
  useEffect(() => {
    // Ao montar o componente, verifica se há um valor armazenado no localStorage
    const storedHideFilter = localStorage.getItem('hideFilterDashboard');
    if (storedHideFilter !== null) {
      setHideFilter(storedHideFilter === 'true');
    }

    const handleClickOutside = (event) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        iconRef.current &&
        iconRef.current.contains(event.target)
      ) {
        setHideFilter(true);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggleFilter = () => {
    // Lê os valores atuais do localStorage
    const homePagePreference = parseInt(localStorage.getItem('homePagePreference')) || 0;
    const currentHideFilterDashboard = localStorage.getItem('hideFilterDashboard') === 'true';

    // Alterna o valor de hideFilterDashboard
    const newHideFilterDashboard = !currentHideFilterDashboard;

    // Salva o novo valor no localStorage
    localStorage.setItem('hideFilterDashboard', newHideFilterDashboard.toString());

    // Atualiza o estado
    setHideFilter(newHideFilterDashboard);

    // Cria objeto de preferências do usuário com o novo valor de hideFilterDashboard
    const userPreferences = {
      homePagePreference,
      hideFilterDashboard: newHideFilterDashboard
    };

    // Chama o serviço para salvar as preferências do usuário
    //console.log("User preferences: " + userPreferences);
    UserPreferenceService.insert(userPreferences)
      .then(() => {
        // Você pode adicionar lógica adicional aqui após o sucesso da inserção
        //console.log('Preferências do usuário salvas com sucesso');
      })
      .catch((error) => {
        // Lógica de erro
        console.error('Erro ao salvar as preferências do usuário:', error);
      });
  };

  const handleIconClick = (e) => {
    e.stopPropagation();
    handleToggleFilter();
  };

  const handleDivClick = () => {
    if (hideFilter) {
      setHideFilter(false);
    }
  };

  useEffect(() => {
    // Atualiza o localStorage sempre que hideFilter mudar
    localStorage.setItem('hideFilterDashboard', hideFilter.toString());
  }, [hideFilter]);

  useEffect(() => {
      BranchService.getAllList().then((response: any) => {
        if (response.success) {
          let branchList = response.result.datasets.filter((dataset) => {
            return dataset.dataset === "branch";
          });
          const sort = branchList
            ? branchList[0].data?.sort((a, b) =>
              a.fullName.localeCompare(b.fullName)
            )
            : [];
          setBranches(sort);
        } else {
          setBranches([]);
        }
      });
  }, []);

  useEffect(() => {
    const initialize = async () => {
      setDatasetDashboardCore(await getList(null));

      //await getequipmentMonit();

      await fetchProgramEquipmentContingencyConfig();

      await fetchRecentPickupAlertConfig();

      await fetchConfigValue();

      LocaleService.getAll().then((response: any) => {
        setLocales(response.result);
      });

      TransporterService.getAll().then((response: any) => {
        if (response.success) {
          let transporterList = response.result.datasets.filter((dataset) => {
            return dataset.dataset === "transporter";
          });
          const sort = transporterList
            ? transporterList[0].data?.sort((a, b) =>
              a.fullName.localeCompare(b.fullName)
            )
            : [];
          setTransporters(sort);
        } else {
          setTransporters([]);
        }
      });

      PickupStatusService.getAll().then((response: any) => {
        if (response.success) {
          setCollectionForecastColor(
            response.result.filter((item) => {
              return item.id == 0;
            })[0].pickupColor
          );
          setInPlanCollectionServiceColor(
            response.result.filter((item) => {
              return item.id == 1;
            })[0].pickupColor
          );
          setPlanedCollectionServiceColor(
            response.result.filter((item) => {
              return item.id == 4;
            })[0].pickupColor
          );
          setScheduledCollectionServiceColor(
            response.result.filter((item) => {
              return item.id == 12;
            })[0].pickupColor
          );
          setExecutedCollectionServiceColor(
            response.result.filter((item) => {
              return item.id == 7;
            })[0].pickupColor
          );
        } else {
          setCollectionForecastColor("");
          setInPlanCollectionServiceColor("");
          setPlanedCollectionServiceColor("");
          setScheduledCollectionServiceColor("");
          setExecutedCollectionServiceColor("");
        }
      });

      let dba = datasetDashboardAnalytical;

      let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [dba] };

      requestParams.parameters = {
        ...requestParams.parameters
      }
      /*
         Sprint 34 - Remover no futuro
            Contador para controlar o modal, para habilitar ou desabilitar
         */
      // Chama o método getFeatureCount com featureId, codeType e refId todos iguais a 1
      ConfigFeatureService.getFeatureCount(1, 1, 1)
        .then((response: any) => {
          //console.log("Count:", response); // Exibe a contagem no console para depuração
          if (response === 1) {
            // Chama o serviço EquipmentAcknowledgeService para buscar os dados e lidar com a resposta
            EquipmentAcknowledgeService.getEquipmentImposedPickupModal(requestParams).then((response: any) => {
              if (response.success) {
                if (response.result.datasets[0].data) {
                  setModalEquipmentImposeShow(true);
                  setEquipmentImposeList(response.result.datasets[0].data);
                }
              }
            }).catch((error) => {
              console.error("Erro ao buscar o modal de imposição de equipamento:", error);
            });
          } else {
            // Caso o count não seja 1, exibe uma mensagem no console
            //console.log("A contagem não é 1, nenhuma ação adicional será realizada.");
          }
        })
        .catch((error) => {
          // Lida com possíveis erros da chamada ao getFeatureCount
          console.error("Erro ao verificar a contagem de features:", error);
        });

    };

    initialize();
  }, []);

  const handleCloseModal = () => {
    setJustification('');
    // Limpar a justificativa ao fechar o modal
    handleJustificationChange('');
    if (selectedEquipmentDataWithDays && selectedEquipmentDataWithDays.length > 0) {
      const updatedSelectedEquipmentDataWithDays = selectedEquipmentDataWithDays.map(equipment => {
        if (equipment.is_checked_prog_status === false) {
          return {
            ...equipment,
            is_checked_prog_status: true,
          };
        }
        return equipment;
      });

      // Atualizar o estado dos dados selecionados
      setSelectedDataDashboard(updatedSelectedEquipmentDataWithDays);
    }
    setShowScheduleModal(false);
    setShowIsDangerModal({
      open: false,
      item: null,
      dayColumn: null,
      forced: null,
    });
    setJustification('');
    // Limpar a justificativa ao fechar o modal
    handleJustificationChange('');
  };

  const handleCloseModalGeneralInformation = () => {
    setModalGeneralInformation(false);
  };

  const handleCloseModalGeneralCaption = () => {
    setModalGeneralCaption(false);
  };

  useEffect(() => {
    setDatasetDashboardCore((prevState) => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        percentage_balance_online: percentageBalanceOnline, // Atualiza o filtro
      },
    }));
  }, [percentageBalanceOnline]);


  /*
  Sprint 29
  Função responsável para poder criar os dados
  fazer a procedure para ter os dados de exportação
  handle referente ao Coleta Imposta
*/
    const handleExportButtonClick = (Type: string) => {
    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetDashboardAnalytical] };

    requestParams.parameters = {
      ...requestParams.parameters,
        Type
    }

        EventExportService.ExportEquipmentImposedWithoutCollection(requestParams, Type).finally(() =>
        Type
    );

  };

  const ListYesNo = [
    {
      id: 1,
      title: 'YES'
    },
    {
      id: 2,
      title: 'NO'
    }
  ]

  const selectedDataDashboardReducer = (state, action) => {
    switch (action.type) {
      case 'UPDATE_CHECKBOX':
        return state.map(data =>
          (data.id_equipment === action.idEquipment && data.day_name === action.dayName)
            ? { ...data, is_checked_prog_status: action.newStatus }
            : data
        );
      default:
        return state;
    }
  };

  /**
   * Documentação do código da parte do modal
   * Este código lida com a exibição de um modal de programação de coleta de equipamentos.
   * Dados o valor do MIN_PERC_PICKUP e o alerta de programação abaixo ativo, vamos realizar
   * cálculos e ver se os valores deve aparecer ou não no modal de acordo com a regra.
   */


  /**
   * Estado para armazer na informação da justificativa escrita no textarea do modal
   * Utilizado no hanleJustificationChange para atualizar o estado com a justificativa
   * inserida pelo usuário.
   * Se a justificativa estiver vazia e certas condições de estado estiverem presente, o botão
   * "YES" será desabilitado, impedindo a confirmação da programação.
   *  */
  const [justification, setJustification] = useState('');

  /**
   * O dataset contém informações de configuração que são necessária para filtrar e buscar
   * dados de configuração do equipamento.
   * Usando em fetchConfigValue, para preparar a solicitação de configuração
   * Ele vai trazer os dois campos, de alerta e valor minimo de programação
   */
  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)), dataset: 'config', filters: {
      config_key: [],
      config_value: [],
      description: []
    },
    sort: {
      field: 'key',
      orientation: 'asc'
    }
  });

  // Verifica se selectedDataDashboard está definido antes de acessar métodos de array
  const selectedEquipments = selectedDataDashboard;
  //console.log("selectedEquipments", selectedEquipments)
  /**
   * Armazena o valor de configuração "EQUIP_BELOW_MIN_FOR_APPROVAL", para sabemos se o 
   * alerta está ligado ou desligado. Ele é atualizado no fetchConfigValue, após a recuperação
   * dos dados de configuração;
   */
  const [configValue, setConfigValue] = useState(false);
  /**
   * Mantém o estado atual dos checkboxes, identificando quais equipamentos foram
   * selecionados ou desmarcados. Utilizado no handleCheckboxChange par atualziar o 
   * estado quando um checkbox é alterado.
   */
  const [checkboxState, setCheckboxState] = useState({});
  /**
   * Controla o estado de habilitação do botão "YES". Modificado em updateDisableYesButton.
   */
  const [disableYesButton, setDisableYesButton] = useState(true);
  
  /**
   * Alternar o estado dos checkboxes de equipamentos quando o usuário clica em um 
   * checkbox específico. Permite que o usuário selecione ou desmarque os equipamento da lista
   * atualizando o estado interno e, consequentemente, a exibição no modal. Passado, como
   * propriedade no ModalProgPickup e é acionado toda vez que um checkbox é clicado.
   */
  // Defina um estado temporário para armazenar os estados atualizados

  const handleCheckboxChange = (idEquipment, dayName) => {
    // Definir uma constante para verificar o estado anterior e o novo estado
    const previousState = checkboxState[`${idEquipment}-${dayName}`];
    const newCheckboxState = !previousState;
    // Atualiza apenas o estado visual inicialmente
    setCheckboxState((prevState) => ({
      ...prevState,
      [`${idEquipment}-${dayName}`]: newCheckboxState,
    }));

  };


  /**
   * Atualiza o estado de justicativa com o valor e recalcula o status do botão YES.
   * Passado como propriedade no ModalProgPickup e é aciionado quando perde o foco no campo de justificar.
   */
  const handleJustificationChange = useCallback((newJustification) => {
    //console.log("Justification updated:", newJustification); // Verifique o valor diretamente
    setJustification(newJustification); // Atualiza o estado com a justificativa final
    updateDisableYesButton(configValue);
  }, []);

  /**
   * Verifica se o botão "YES" deve ser habilitado ou desabilitado com base no estado
   * atual de seleção de equipamentos e presença de justificativa.
   * 
   * @param configValue 
   * @returns 
   */
  const updateDisableYesButton = (configValue) => {
    if (!configValue) {
      setDisableYesButton(false);
      return;
    }

    const isJustificationFilled = justification.trim() !== '';
    // Se todos os equipamentos estiverem marcados e a justificativa estiver vazia, desabilitar o botão "Yes"
    const allUncheckedAndEmptyJustification = ((totalCount - checkedCount) === 0) && isJustificationFilled;
    const uncheckedAndEmptyJustification = ((totalCount - uncheckedCount) === 0);


    // Verificar se totalCount é 0
    if (totalCount === 0) {
      setDisableYesButton(false);
      return;
    }

    const difference = selectedEquipments.length - (totalCount - checkedCount);

    if (difference === 0) {
      setDisableYesButton(true); // Desabilita o botão
      return;
    }

    // Se totalCount - uncheckedCount for maior que 1, desabilitar o botão "Yes"
    if ((totalCount - uncheckedCount >= 1) && !isJustificationFilled) {
      setDisableYesButton(true);
      return;
    }


    // Definir a lógica para desabilitar o botão "Yes"
    if (totalCount - checkedCount === 0) {
      setDisableYesButton(!allUncheckedAndEmptyJustification);
    } else {
      setDisableYesButton((allUncheckedAndEmptyJustification && !uncheckedAndEmptyJustification));
    }

  };

  // Supondo que selectedEquipments seja uma array de IDs de equipamentos
  const selectedEquipmentIds = selectedEquipments?.map(equipment => equipment.id_equipment);
  //console.log("selectedEquipmentIds", selectedEquipmentIds)
  // Iterar sobre datasetDashboardCore?.data para encontrar informações dos equipamentos selecionados
  //console.log("DataseDahboarCore", datasetDashboardCore)
  const selectedEquipmentData = datasetDashboardCore?.data?.filter(data => selectedEquipmentIds?.includes(data.idEquipment));
  //console.log("selectedEquipmentData", selectedEquipmentData)

  const daysOfWeek = {
    0: t('SUNDAY_NICK'),
    1: t('MONDAY_NICK'),
    2: t('TUESDAY_NICK'),
    3: t('WEDNESDAY_NICK'),
    4: t('THURSDAY_NICK'),
    5: t('FRIDAY_NICK'),
    6: t('SATURDAY_NICK'),
  };

  // Supondo que EquipmentConfigService.getByEquipment é uma função assíncrona
  // Função assíncrona para buscar a configuração do equipamento
  // Estado para armazenar as configurações mínimas de coleta
  ///correção
  // const [minimumPickupConfigs, setMinimumPickupConfigs] = useState({});
  // const fetchEquipmentConfig = async (equipmentId) => {
    
  //       const equipmentConfigs = selectedEquipmentData.find(item => item.idEquipment === equipmentId);

  //       // Filtrar para encontrar o configKey 'minimum_value_for_pickup'
  //       const minimumPickupConfig = equipmentConfigs.minimumValueForPickup;

  //       const minimumPickupPhysicalConfig = equipmentConfigs.minimumPercentageForPhysicalPickup;
  
  //       const configValue = minimumPickupConfig ? minimumPickupConfig.configValue : null;

  //       const configValuePhysical = minimumPickupPhysicalConfig ? minimumPickupPhysicalConfig.configValue : null;

  //       return { configValue, configValuePhysical };
  // };
  

  // Função para buscar configurações mínimas para todos os equipamentos
  // const fetchAllEquipmentConfigs = () => {
  //   if (selectedEquipments) {
  //     // Para cada equipamento selecionado, busque a configuração mínima
  //     selectedEquipments.forEach(selectedEquipment => {
  //       fetchEquipmentConfig(selectedEquipment.id_equipment)
  //         .then(({ configValue, configValuePhysical }) => {
  //           setMinimumPickupConfigs((prevConfigs) => ({
  //             ...prevConfigs,
  //             [selectedEquipment.id_equipment]: {
  //               minimumValueForPickup: configValue,
  //               minimumPercentageForPhysicalPickup: configValuePhysical,
  //             },
  //           }));
  //         })
  //         .catch(error => {
  //           console.error(`Erro ao buscar configuração para equipamento ${selectedEquipment.id_equipment}:`, error);
  //         });
  //     });
  //   }
  // };

  // UseEffect para buscar as configurações de todos os equipamentos
  // useEffect(() => {
  //   //fetchAllEquipmentConfigs();
  // }, [selectedEquipments]);

  // Arrays separados para armazenar os equipamentos válidos e inválidos
  const renderPeriodDescription = () => {
    //console.log("Render Period Description", datasetDashboardCore.filters.monit_equipment);

    // Verifica se monit_equipment é diferente de null
    const isMonitoringActive = datasetDashboardCore.filters.monit_equipment !== null;

    const currentDate = isMonitoringActive
      ? moment() // Data de hoje
      : moment(currentDay); // Data atual mantida se for null

    // Atualiza currentDay apenas se necessário
    if (isMonitoringActive && !currentDay.isSame(moment(), "day")) {
      setCurrentDay(moment());

    }

    const currentDatePlusDays = currentDate.clone().add(6, "days"); // Adiciona 6 dias

    return (
      <>
        <strong>{t(currentDate.format("MMMM").toUpperCase())}</strong> {currentDate.date()} - {currentDatePlusDays.date()}
      </>
    );
  };

  //const [currentDay, setCurrentDay] = useState(new Date());
  const [currentDay, setCurrentDay] = useState(moment());

  //const [isEqualTo8DaysAgo, setIsEqualTo8DaysAgo] = useState(false);
  //const [isEqualToDay, setIsEqualToDay] = useState(false);



  useEffect(() => {
    handleSearch();
  }, [currentDay]);

  useEffect(() => {
    // Verifica se a data é igual a 7 dias atrás
    const check8DaysAgo = currentDay.isSame(moment().subtract(7, 'days'), 'day');
    // Verifica se a data é igual data atual
    const checkDay = currentDay.isSame(moment(), 'day');
    isEqualToDayG = checkDay;
    // Atualiza os estados booleanos com base nas verificações
    setIsEqualTo8DaysAgo(check8DaysAgo);
    setIsEqualToDay(checkDay);

  }, [currentDay]); // Atualiza sempre que currentDay mudar

  const addDayToPeriod = async (value) => {
    const newCurrentDay = moment(currentDay).add(value, "days");
    const formattedDate = moment(newCurrentDay).format("YYYY-MM-DD");


    setCurrentDay(newCurrentDay);

    if (newCurrentDay.isSame(moment(), "day")) {
      updateColumnByDate(null); // Passa null para a função updateColumnByDate
    } else {
      updateColumnByDate(formattedDate); // Passa a data formatada para a função updateColumnByDate
    }

  };

  const updateColumnByDate = async (date) => {
    // Obter a data de hoje no mesmo formato de `date` (supondo que seja uma string no formato ISO ou similar)
    const today = new Date().toISOString().split('T')[0]; // Apenas a parte da data no formato 'YYYY-MM-DD'
    const historyDateFilter = date === today ? null : [date];

    //handleClean();
    setDatasetDashboardCore({
      ...datasetDashboardCore,
      filters: {
        ...datasetDashboardCore.filters,
        history_date_filter: historyDateFilter,
        monit_equipment: null,
      },
    });
    // Limpa a seleção de monitoramento
    handleClickMonitoring(null);
  }

    const selectedEquipmentDataWithDays = selectedEquipments?.map(selectedEquipment => {
    const programming_date = new Date(selectedEquipment.pickup_date + 'T00:00:00');
    const dayIndex = programming_date.getDay();
    const dayOfWeek = daysOfWeek[dayIndex];

    // Filtrar isChecked para o equipment atual
    const isChecked = selectedDataDashboard?.filter(data =>
      data.id_equipment === selectedEquipment.id_equipment &&
      data.day_name === selectedEquipment.day_name
    );
    // Verificar se isChecked existe e extrair day_name
    const day_name = selectedEquipment.day_name;
    //console.log("day", day_name);
    // Encontrar o datasetEntry correspondente ao code_equipment em datasetDashboardCore.data
    //console.log("datasetEntry", datasetDashboardCore)
    const datasetEntry = datasetDashboardCore?.data.find((entry: any) => entry.codeEquipment === selectedEquipment.code_equipment);
    //console.log("datasetEntry1", datasetEntry)
    // Verificar se datasetEntry existe antes de acessar seus valores

    let selected_collection_percentage = 0;
    let dayNameValue = null;
    let limitContractual = 0;
    let limitMonetaryValue = 0;
    let dynamicPropertyName = null;
    let limitPhysicalValue = 0;
    let dayNamePhysicalValue = null;

    if (datasetEntry) {
      const { limitContractual: datasetLimitContractual, limitMonetary, limitPhysical, ...otherProps } = datasetEntry;
      limitContractual = datasetLimitContractual;
      limitMonetaryValue = limitMonetary;
      limitPhysicalValue = limitPhysical;

      // Calcular selected_collection_percentage se limitContractual for diferente de 0
      if (limitContractual !== 0) {
        let selected_collection_percentage = (limitMonetary / limitContractual) * 100;
        selected_collection_percentage = Math.round(selected_collection_percentage);
      }
      // Formar o nome da variável dinamicamente
      dynamicPropertyName = `${day_name}Border`;
      // Calcular day_name + "Value"
      dayNameValue = datasetEntry[`${day_name}Value`];

      dayNamePhysicalValue = datasetEntry[`${day_name}ValueBanknotes`];


      // Obter o valor de day_nameBorderValue
      const day_nameBorderValue = datasetEntry[dynamicPropertyName];

      // Verificar se day_nameBorderValue é uma cor específica ('#96cbff' neste exemplo)
      if (day_nameBorderValue &&
        (day_nameBorderValue.toLowerCase() === '#96cbff' || day_nameBorderValue.toLowerCase() === '#ffff99')) {
        return null; // Retorna null para filtrar este item da listagem
      }
    }

    // Obter a configuração mínima do estado
    //const minPickupConfig = minimumPickupConfigs[selectedEquipment.id_equipment] || {};

    //const minPickupConfig = selectedEquipment.minimumValueForPickup || {};

    // Garantir que os valores sejam convertidos para número antes de dividir
    const minPickupValue = datasetEntry.minimumValueForPickup != null ? (Number(datasetEntry.minimumValueForPickup) || 0)  : 0;
    const minPercPickupFor100 = minPickupValue / 100;

    const minPickupPhysicalValue = Number(datasetEntry.minimumPercentageForPhysicalPickup) || 0;
    const minPercPickupPhysicalFor100 = minPickupPhysicalValue / 100;


    /**
     * Vamos fazer os calculos das previsões que estão abaixo, vamos se baser no limite contratado que é mostrado em tela.
     * se o valor mostrado na previsão, for menor que o valor da porcentagem, ele será exibido no modal
     * fazer isso para monetário e físico.
     */

    // Monetário:
    //Pegar o valor da porcentagem e saber os valores que estão abaixo dele
    const equipmentBelowMonetaryPercentage = limitContractual * minPercPickupFor100
    //console.log("equipmentAbaixoDaPorcentagemMonentaria", equipmentBelowMonetaryPercentage)

    // Físico:
    // Pegar o valor da porentagem e saber os valores do que estão abaixo
    const equipmentBelowPhysicalLimit = dayNamePhysicalValue * minPercPickupPhysicalFor100;
    //console.log("minPickupValue", minPickupValue, Math.round((dayNameValue / limitContractual) * 100))
    //console.log("minPickupPhysicalValue", minPickupPhysicalValue, Math.round((dayNamePhysicalValue / limitPhysicalValue ) * 100))

    const isPercentgeValidMonentario = minPickupValue ? (Math.round((dayNameValue / limitContractual) * 100) < minPickupValue) : false;
    //console.log("dayNameValue: ", dayNameValue, equipmentBelowMonetaryPercentage);

    const isPercentgeValidPhysical = minPickupPhysicalValue ? (Math.round((dayNamePhysicalValue / limitPhysicalValue) * 100) < minPickupPhysicalValue) : false;
    //console.log("dayNamePhysicalValue: ", dayNamePhysicalValue, equipmentBelowPhysicalLimit);
    const selected_collection_percentage_physical = limitPhysicalValue !== 0 ? Math.round((dayNamePhysicalValue / limitPhysicalValue) * 100) : 0;

    // Calcular equipmentPickupPercentage
    const equipmentPickupPercentage = limitContractual !== 0 ? Math.round((dayNameValue / limitContractual) * 100) : 0;

    const isMonetaryValid = (minPickupValue !== 0 && limitContractual !== 0)
      ? (Math.round((dayNameValue / limitContractual) * 100) < minPickupValue)
      : true;

    const isPhysicalValid = (minPickupPhysicalValue !== 0 && limitPhysicalValue !== 0)
      ? (Math.round((dayNamePhysicalValue / limitPhysicalValue) * 100) < minPickupPhysicalValue)
      : true;

    // Se os dois forem 0, não entra na lista
    if (minPickupValue === 0 && minPickupPhysicalValue === 0) {
      return null;
    }



    // Se ambos os parâmetros são maiores que zero, então ambos precisam ser válidos
    if (minPickupValue > 0 && minPickupPhysicalValue > 0) {
      if (!isMonetaryValid || !isPhysicalValid) {
        return null;
      }
    }

    const shouldIncludeEquipment = (
      (minPickupValue === 0 || isMonetaryValid) &&
      (minPickupPhysicalValue === 0 || isPhysicalValid)
    );

    const day_BorderValue = datasetEntry[`${day_name}Border`];
    // Indica que a coleta está abaixo do valor mínimo, mas não exige justificativa, 
    // pois foi sugerida automaticamente pelo sistema devido a restrições no dia ideal (sugestão rosa).    
    const pickupunderminsyssuggestednojustification =   day_BorderValue && day_BorderValue.toLowerCase() === '#ffd6d6';

    // Comparar dayNameValue com minPercPickup
    const isPercentageValid = shouldIncludeEquipment;
    //console.log("isPercentageValid", isPercentageValid, selectedEquipment.code_equipment, selectedEquipment.day_name, equipmentPickupPercentage);
    if (shouldIncludeEquipment) {
      return {
        ...selectedEquipment,
        dayOfWeek,
        idEquipment: selectedEquipment.id_equipment,
        code_equipment: selectedEquipment.code_equipment,
        day_name: selectedEquipment.day_name,
        isChecked: isChecked,
        selected_collection_percentage: selected_collection_percentage,
        dayNameValue: dayNameValue,
        isPercentageValid: isPercentageValid,
        equipmentPickupPercentage: equipmentPickupPercentage,
        selected_collection_percentage_physical: selected_collection_percentage_physical,
        dayNamePhysicalValue: dayNamePhysicalValue,
        // Indica que a coleta está abaixo do valor mínimo, mas não exige justificativa, 
        // pois foi sugerida automaticamente pelo sistema devido a restrições no dia ideal (sugestão rosa).        
        pickupunderminsyssuggestednojustification:pickupunderminsyssuggestednojustification
      };
    };


    return null;
  }).filter(item => item !== null);


  /**
   * Executa quando o modal de programação de coleta é exibido ou
   * quando os dados de equipamento selecionados mudam. Assegura que os dados de
   * configuração estejam sempre atualizados antes de exibir ou interagir com o modal,
   * garantindo que o usuário tenha as informações mais recentes.
   */
  useEffect(() => {
    if (showScheduleModal || selectedEquipmentDataWithDays) {
       fetchConfigValue();
    }
   }, [showScheduleModal]);


  useEffect(() => {
    if (selectedDataDashboard) {
      const initialCheckboxState = selectedDataDashboard.reduce((acc, data) => {
        const checkboxId = `${data.id_equipment}-${data.day_name}`;
        acc[checkboxId] = data.is_checked_prog_status !== undefined ? data.is_checked_prog_status : true;
        return acc;
      }, {});
      setCheckboxState(initialCheckboxState);
    }
  }, [showScheduleModal]);


  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      console.log();
    }
  }, [justification]);



  let equipmentInfoArray = [];
  let combinationsFound = new Set();

  selectedEquipmentData?.forEach(data => {
    const selectedEquipmentsForData = selectedEquipmentDataWithDays?.filter(equipment => equipment.id_equipment === data.idEquipment);
    selectedEquipmentsForData?.forEach(selectedEquipment => {
      const { code_equipment, pickup_date } = selectedEquipment;


      selectedEquipment.isChecked?.forEach(isChecked => {
        const { day_name } = isChecked;
        // Verifica se o day_name pertence ao mesmo code_equipment
        if (isChecked.code_equipment === code_equipment) {
          const combination = `${code_equipment}-${pickup_date}-${day_name}`;

          // Verifica se a combinação já foi registrada
          if (!combinationsFound.has(combination)) {
            combinationsFound.add(combination);

            const dayNameValueKey = `${day_name}Value`;
            const dayValue = data[dayNameValueKey];

            const dayNameValueKeyPhysical = `${day_name}ValueBanknotes`;
            const dayValuePhysical = data[dayNameValueKeyPhysical];

            const dayBorderValueKey = `${day_name}Border`;
            //console.log("Border",dayBorderValueKey);
            const dayBorderValue = data[dayBorderValueKey];
            //console.log("Color",dayBorderValue)

            // Indica que a coleta está abaixo do valor mínimo, mas não exige justificativa, 
            // pois foi sugerida automaticamente pelo sistema devido a restrições no dia ideal (sugestão rosa).
            const pickupunderminsyssuggestednojustification=   dayBorderValue && dayBorderValue.toLowerCase() === '#ffd6d6';
            // Verificação para ignorar se dayBorderValue for igual a #FFFF99
            if (dayBorderValue === "#FFFF99") {
              console.log(``);
              return; // Pula para o próximo item
            }
            

            // Encontrar o datasetEntry correspondente ao code_equipment em datasetDashboardCore.data
            const datasetEntry = datasetDashboardCore?.data.find((entry: any) => entry.codeEquipment === code_equipment);
            //console.log("DatasetEntry", JSON.stringify(datasetEntry));
            if (datasetEntry) {

              const { limitContractual, balanceOnline, limitPhysical } = datasetEntry;

              const programming_date = new Date(pickup_date);
              const adjustedDate = new Date(pickup_date);
              adjustedDate.setHours(programming_date.getHours() + 3);

              // Obtém o nome do dia da semana em inglês
              const dayOfWeek = adjustedDate.toLocaleString('en-US', { weekday: 'long' });

              let configValueBranch = configValue;

              if (configValueBranch !== false) {
                const retconfigbranch = branches
                  ?.find((entry: any) => entry.id === datasetEntry.branchId)
                  ?.branchEquipBelowMinForApproval;

                  if (retconfigbranch === false || retconfigbranch === true) configValueBranch = retconfigbranch;
              }

              const info = {
                code_equipment: code_equipment,
                current_forecast_value: dayValue,
                contractual_limit_value: limitContractual,
                balance_online: balanceOnline,
                selected_collection_percentage: Math.round((dayValue / limitContractual) * 100),
                pickup_date: programming_date.toISOString(),
                current_date: new Date().toISOString(),
                // Indica que a coleta está abaixo do valor mínimo, mas não exige justificativa, 
                // pois foi sugerida automaticamente pelo sistema devido a restrições no dia ideal (sugestão rosa).                
                justification: !configValueBranch
                    ? "Alerta Desligado"
                    : pickupunderminsyssuggestednojustification === true
                        ? t("COLLECTION_SCHEDULE.COLLECTION_BELOW_MINIMUM_SUGGESTED_BY_BDP")
                        : justification,
                day_name: day_name,
                day_of_week: dayOfWeek,
                is_checked_prog_status: configValueBranch
                  ? checkboxState[`${isChecked.id_equipment}-${isChecked.day_name}`]
                  : true, // Se configValue for false, definir como true
                is_programming_approved: configValueBranch ? false : true, // Se configValue for false, definir como true
                decision_programming: configValueBranch ? null : true, // Se configValue for false, definir como true
                selected_collection_percentage_physical: Math.round((dayValuePhysical / limitPhysical) * 100),
                dayNamePhysicalValue: dayValuePhysical,
                contractual_limit_physical_value: limitPhysical,
                // Indica que a coleta está abaixo do valor mínimo, mas não exige justificativa, 
                // pois foi sugerida automaticamente pelo sistema devido a restrições no dia ideal (sugestão rosa).                
                pickupunderminsyssuggestednojustification:pickupunderminsyssuggestednojustification
              };
              //console.log("info: " + JSON.stringify(info));
              equipmentInfoArray.push(info);
            } else {
              console.error(`Não foi possível encontrar informações para code_equipment "${code_equipment}" em datasetDashboardCore.data.`);
            }
          }
        } else {
          // console.warn(`O day_name "${day_name}" não pertence ao code_equipment "${code_equipment}". Ignorando este valor.`);
        }
      });
    });
  });

  // Verificar cada item do equipmentInfoArray
  equipmentInfoArray = equipmentInfoArray.filter(info => {
    // Verificar se a combinação de code_equipment, day_name e pickup_date está em isChecked
    const foundInIsChecked = selectedEquipmentDataWithDays.some(equipment => {
      return equipment.isChecked?.some(isChecked => {
        return isChecked.code_equipment === info.code_equipment &&
          isChecked.day_name === info.day_name &&
          new Date(isChecked.pickup_date).toISOString() === new Date(info.pickup_date).toISOString();
      });
    });

    // Retornar verdadeiro se encontrado em isChecked, caso contrário, remover do array
    return foundInIsChecked;
  });
  //console.log("equipmentInfoArray: " + JSON.stringify(equipmentInfoArray));
  // Contar quantos têm is_checked_prog_status como true e false
  const totalCount = equipmentInfoArray.length;
  const checkedCount = equipmentInfoArray.filter(info => info.is_checked_prog_status).length;
  const uncheckedCount = equipmentInfoArray.filter(info => !info.is_checked_prog_status).length;

  useEffect(() => {
    updateDisableYesButton(configValue);
  }, [selectedEquipmentDataWithDays, justification]);

  async function fetchAssociations(ids) {
    try {
      const response = await  MultiEquipmentGroupService.getAllById(ids);
      // Aqui o resultado real da API está dentro de response.data

      const result = response.result; 

      if (!Array.isArray(result)) {
        console.error('Formato inesperado da resposta:', result);
        return;
      }

      const mapped = result.map(item => ({
        equipment: Number(item.equipment),
        associated: item.associated.map(Number)
      }));

      setSelectedEquipmentsForAssociationitems(mapped);
    } catch (error) {
      console.error('Erro ao buscar associações:', error);
    }
  }

    async function fetchJustification() {
    try {
      const response = await  MinimumValuePickupJustifyJustificationService.getAll();
      // Aqui o resultado real da API está dentro de response.data

      const result = response.result; 

      if (!Array.isArray(result)) {
        console.error('Formato inesperado da resposta:', result);
        return;
      }

      const mapped = result.map(item => ({
        justification: item.justification
      }));
      setpickupJustifyJustificationList(mapped);
    } catch (error) {
      console.error('Erro ao buscar associações:', error);
    }
  }
  
  const foundRecentPickupAlert = (selectedDataDashboardRef?.current ?? []).find(
  item => item?.flagRecentPickupAlert === true);

  return (
    <>
      <ModalProgPickup
        isLoading={isLoading}
        Title={t("DASHBOARD.SCHEDULE")}
        Message={
          enableRecentPickupAlert && foundRecentPickupAlert
            ? t("CONFIG.ALERT_RECENT_PICKUP_ALERT")
            : t("DASHBOARD.SCHEDULE_ANSWER")
        }
        close={handleCloseModal}
        cancel={t("CANCEL")}
        show={showScheduleModal}
        selectedDataDashboard={selectedEquipmentDataWithDays}
        handleJustificationChange={handleJustificationChange}
        handleCheckboxChange={handleCheckboxChange}
        // allUnchecked={allUnchecked}
        disableYesButton={disableYesButton}
        justification={justification}
        configValue={configValue}
        checkboxState={checkboxState}
        totalCount={totalCount}
        checkedCount={checkedCount}
        uncheckedCount={uncheckedCount}
        selectedEquipmentsForAssociation= {selectedEquipmentsForAssociationitems}
        pickupJustificationList = {pickupJustifyJustificationList}
      >
        <Button
          disabled={isLoading || (disableYesButton && selectedEquipmentDataWithDays?.some(item => item.pickupunderminsyssuggestednojustification !== true && item.flag_branchEquipBelowMinForApproval == true))}
          variant='primary'
          onClick={sendSelectedDay}>
          {isLoading ? (
            <span>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{" "}
              {t("LOADING")} {/* Texto de carregamento enquanto está processando */}
            </span>
          ) : (
            t("YES")
          )}
        </Button>
      </ModalProgPickup>

      <ModalAlertList
        Title={t("MODULE_ALERT.ALERTS")}
        ListAlert={alertList}
        ButtonCloseLabel={`${t("MODULE_ALERT.CLOSE")}`}
        HandleClose={handleCloseModalAlertList}
        Show={modalAlertListShow}></ModalAlertList>

      <ModalEquipmentImpose
        Title={t('MODULE_ALERT.ALERTS_FORCED_COLLECTION')}
        ListAlert={equipmentImposeList}
        ButtonCloseLabel={`${t('MODULE_ALERT.AWARE')}`}
        /* 
          Sprint 29
          Chamando o exportar do componente ModalEquipmentImposed
        */
        onExportClick={handleExportButtonClick}
        HandleClose={handleCloseModalEquipmentImpose}
        Show={modalEquipmentImposeShow}>
      </ModalEquipmentImpose>

      <CustomModal
        Title={t("DASHBOARD.FORCED")}
        Message={t("DASHBOARD.ISDANGER_ANSWER")}
        close={handleCloseModal}
        cancel={t("CANCEL")}
        show={showIsDangerModal && showIsDangerModal.open}>
        <Button
          variant='primary'
          onClick={() => {
            sendIsDanger(
              showIsDangerModal.item,
              showIsDangerModal.dayColumn,
              showIsDangerModal.forced
            );
          }}>
          {t("YES")}
        </Button>
      </CustomModal>

      <ModalGeneralInformation
        close={handleCloseModalGeneralInformation}
        show={showModalGeneralInformation}
        pdfFileName={"InfoLegend.pdf"}
        ButtonCloseLabel={`${t(
          "MODULE_ALERT.CLOSE"
        )}`}></ModalGeneralInformation>


      {showModalGeneralCaption && (
        <ModalGeneralCaption
          close={handleCloseModalGeneralCaption}
          show={showModalGeneralCaption}
          collectionForecastColor={collectionForecastColor}
          inPlanCollectionServiceColor={inPlanCollectionServiceColor}
          planedCollectionServiceColor={planedCollectionServiceColor}
          scheduledCollectionServiceColor={scheduledCollectionServiceColor}
          executedCollectionServiceColor={executedCollectionServiceColor}

        />
      )}

      {/* <HeaderList title={t("DASHBOARD.TITLE_LIST")} /> */}
      {/* <Preloader show={isLoading} /> */}
      <Form>

        {/* MONITORAMENTO */}

        <MonitoringBar
          data={monitoringData}
          clickMonitoring={handleClickMonitoring}
        />

        <div
          ref={filterRef}
          id="filterRefId"
          style={{ position: 'relative', minHeight: '40px', display: 'flex' }}
          className="custom-line mb-2"
          onClick={handleDivClick}
        >
          <h5 style={{ position: 'absolute', top: '10px', left: '25px' }}>
            {t("FILTERS")}
          </h5>
          <div
            ref={iconRef}
            style={{ position: 'absolute', top: '10px', right: '10px' }}
            onClick={handleIconClick}>
            <FontAwesomeIcon icon={!hideFilter ? faAngleUp : faAngleDown} />
          </div>
          {!hideFilter &&
            <div>
              <div style={{ paddingTop: '30px', alignItems: 'center', paddingLeft: '15px', display: 'flex', flexWrap: 'wrap', paddingRight: '20px', gap: '10px', rowGap: '20px', }}>
                {/* Titulo Coletas - Filtros */}


                {/* Select Filial - Atenção na funcionalidade stopPropagation responsavel por impedir do acordeon expadir ao clicar */}
                <div onClick={async (e) => { e.stopPropagation(); }}>
                  <Form.Floating>
                    <Form.Control
                      as='select'
                      className='form-control'
                      value={
                        datasetDashboardCore?.filters?.branch_id.length >
                          0
                          ? datasetDashboardCore?.filters?.branch_id[0]
                          : ""
                      }
                      onChange={(e) => {
                        if (e.target.value == "") {
                          setDatasetDashboardCore({
                            ...datasetDashboardCore,
                            filters: {
                              ...datasetDashboardCore.filters,
                              branch_id: [],
                              //monit_equipment: [],
                            },
                          });

                        } else {
                          setDatasetDashboardCore({
                            ...datasetDashboardCore,
                            filters: {
                              ...datasetDashboardCore.filters,
                              branch_id: [Number(e.target.value)],
                              //monit_equipment: [],
                            },
                          });
                        }

                        deselectMonitoringOptions();
                      }}>
                      <option value=''>{t("FILTER.SELECT")}</option>
                      {_.map(branches, (item: BranchModel) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.fullName}
                          </option>
                        );
                      })}
                    </Form.Control>
                    <label>{t("FILTER.BRANCH")}</label>
                  </Form.Floating>
                </div>

                {/* Input Codigo do Equipamento - Atenção na funcionalidade stopPropagation responsavel por impedir do acordeon expadir ao clicar*/}
                <div style={{ width: '11rem' }} onClick={(e) => e.stopPropagation()}>
                  <Form.Floating>
                    <Form.Control
                      name='code_equipment'
                      id='code_equipment'
                      type='text'
                      placeholder={t(`FILTER.CODE_EQUIPMENT`)}
                      className='form-control'
                      onChange={(e) => {
                        setDatasetDashboardCore({
                          ...datasetDashboardCore,
                          filters: {
                            ...datasetDashboardCore.filters,
                            code_equipment: [e.target.value],
                          },
                        });
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSearch();
                        }
                      }}
                      value={
                        datasetDashboardCore?.filters?.code_equipment
                          .length > 0
                          ? datasetDashboardCore.filters.code_equipment[0]
                          : ""
                      }
                    />
                    <label>{t("FILTER.EQUIPMENT")}</label>
                  </Form.Floating>
                </div>

                {/* Input Cliente - Atenção na funcionalidade stopPropagation responsavel por impedir do acordeon expadir ao clicar*/}
                <div style={{ width: '11rem' }} onClick={(e) => e.stopPropagation()}>
                  <Form.Floating>
                    <Form.Control
                      name='customer'
                      id='customer'
                      type='text'
                      placeholder={t(`FILTER.CLIENT`)}
                      className='form-control'
                      onChange={(e) => {
                        setDatasetDashboardCore({
                          ...datasetDashboardCore,
                          filters: {
                            ...datasetDashboardCore.filters,
                            customer: [e.target.value],
                          },
                        });
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSearch();
                        }
                      }}
                      value={
                        datasetDashboardCore?.filters?.customer
                          .length > 0
                          ? datasetDashboardCore.filters.customer[0]
                          : ""
                      }
                    />
                    <label>{t("FILTER.CUSTOMER")}</label>
                  </Form.Floating>
                </div>

                {/* Select Modal Imposto - Atenção na funcionalidade stopPropagation responsavel por impedir do acordeon expadir ao clicar */}
                <div style={{ minWidth: '100px' }} onClick={async (e) => { e.stopPropagation(); }}>
                  <Form.Floating>
                    <Form.Control
                      as='select'
                      className='form-control'
                      value={
                        datasetDashboardCore?.filters?.multiclient.length >
                          0
                          ? datasetDashboardCore?.filters?.multiclient[0]
                          : ""
                      }
                      onChange={(e) => {
                        if (e.target.value == "") {
                          setDatasetDashboardCore({
                            ...datasetDashboardCore,
                            filters: {
                              ...datasetDashboardCore.filters,
                              multiclient: []
                            },
                          });

                        } else {
                          setDatasetDashboardCore({
                            ...datasetDashboardCore,
                            filters: {
                              ...datasetDashboardCore.filters,
                              multiclient: [Number(e.target.value)]
                            },
                          });
                        }

                        deselectMonitoringOptions();
                      }}>
                      <option value=''>{t("FILTER.SELECT")}</option>
                      {_.map(ListYesNo, (item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {t(item.title)}
                          </option>
                        );
                      })}
                    </Form.Control>
                    <label>{t("EQUIPMENT.EQUIPMENT_MULTI_CLIENTE")}</label>
                  </Form.Floating>
                </div>
                {/* //0716 - Filtro - equipamentos com Imposição - DashMatriz */}
                <div style={{ minWidth: '100px' }} onClick={async (e) => { e.stopPropagation(); }}>
                  <Form.Floating>
                    <Form.Control
                      as="select"
                      className="form-control"
                      value={
                        datasetDashboardCore?.filters?.equipment_imposition.length >
                          0
                          ? datasetDashboardCore?.filters?.equipment_imposition[0]
                          : ""
                      }

                      onChange={(e) => {
                        if (e.target.value == "") {
                          setDatasetDashboardCore({
                            ...datasetDashboardCore,
                            filters: {
                              ...datasetDashboardCore.filters,
                              equipment_imposition: []
                            },
                          });

                        } else {
                          setDatasetDashboardCore({
                            ...datasetDashboardCore,
                            filters: {
                              ...datasetDashboardCore.filters,
                              equipment_imposition: [Number(e.target.value)]
                            },
                          });
                        }

                        deselectMonitoringOptions();
                      }}>
                      <option value=''>{t("FILTER.SELECT")}</option>
                      {_.map(ListYesNo, (item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {t(item.title)}
                          </option>
                        );
                      })}
                    </Form.Control>

                    <label>{t("DASHBOARD.FILTER_EQUIPMENT_IMPOSITION")}</label>
                  </Form.Floating>
                </div>
                {/* //0716 - Filtro - equipamentos com Imposição - DashMatriz */}
                {/* Filtro Percentagem */}
                <div style={{ width: '8rem' }} onClick={(e) => e.stopPropagation()}>
                  <Form.Floating>
                    <Form.Control
                      as="select"
                      className="form-control"
                      value={percentageBalanceOnline || ""}
                      onChange={(e) => {
                        setPercentageBalanceOnline(e.target.value ? Number(e.target.value) : null); // Atualiza o estado
                      }}
                    >
                      <option value=''>{t("FILTER.SELECT")}</option>
                      {/* <option value="">{t("DASHBOARD_BRANCH.PERCENTAGE")}</option> */}
                      {percentageOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Control>
                    <label>{t("DASHBOARD_BRANCH.PERCENTAGE")}</label>
                  </Form.Floating>
                </div>
                {/* Botão Pesquisar - Atenção na funcionalidade stopPropagation responsavel por impedir do acordeon expadir ao clicar */}
                <div>
                  <ButtonSearch
                    disabled={isLoading}
                    isLoading={isLoading}
                    onClick={async (e) => { e.stopPropagation(); handleSearch(); }}
                  />

                </div>
                <Col xs="auto">
                  <ButtonClean onClick={async (e) => { e.stopPropagation(); handleClean(); }} isLoading={isLoading} />
                </Col>

                {/* Botão Programar/Desprogramar - Atenção na funcionalidade stopPropagation responsavel por impedir do acordeon expadir ao clicar */}

                <div onClick={async (e) => { e.stopPropagation(); }}>
                  {desactiveProgramConfig ? (
                    <>
                      {/* <ButtonProgram
                        text={t("DASHBOARD.SCHEDULE")}
                        isLoading={isLoading}
                        titlePopOver={t("MODAL_DISABLED_PROGRAM_EQUIPMENT.TITLE")}
                      /> */}

                        <Button
                          onClick={async (e) => {
                            e.stopPropagation();
                            const ids = selectedDataDashboard.map(item => item.id_equipment);
                            await fetchAssociations(ids);
                            await fetchJustification();
                            setShowScheduleModal(true);
                            
                          }}
                          disabled={isLoading}
                        >
                          <span>{t("DASHBOARD.SCHEDULE")}</span>
                        </Button>                           
                    </>
                  ) : (
                    <>
                      {(user.profile.profileName === "reader" || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin" || isEqualTo8DaysAgo || selectedDataDashboard?.length > 0 && isEqualTo8DaysAgo || !isEqualToDay) ? (
                        <Button
                          disabled={true} // Desabilita o botão se o perfil for "reader" ou "adm_reader"
                        >
                          <span>{t("DASHBOARD.SCHEDULE")}</span>
                        </Button>
                      ) : (
                        (() => {
                          const isDisabled =
                            desactiveProgramConfig ||
                            !isEqualToDay ||
                            !selectedDataDashboard && !isEqualToDay ||
                            selectedDataDashboard?.length === 0
                            || selectedDataDashboard?.length > 0 && !isEqualToDay;

                          return (
                            // <Button
                            //   onClick={async (e) => { e.stopPropagation(); setShowScheduleModal(true);}}
                            //   disabled={isDisabled}
                            // >
                            //   <span>{t("DASHBOARD.SCHEDULE")}</span>
                            // </Button>
                            <Button
                              onClick={async (e) => {
                                e.stopPropagation();
                                if (!Array.isArray(selectedDataDashboard) || selectedDataDashboard.length === 0) {
                                  ToastService.warn(t("DASHBOARD.NO_EQUIPMENT_SELECTED"),null);
                                  return;
                                }                                
                                const ids = selectedDataDashboard.map(item => item.id_equipment);
                                await fetchAssociations(ids);
                                await fetchJustification();
                                
                                setShowScheduleModal(true);
                              }}
                              disabled={isDisabled}
                            >
                              <span>{t("DASHBOARD.SCHEDULE")}</span>
                            </Button>
                          );
                        })()
                      )}
                    </>
                  )}
                </div>

                {/* Botão exportar - Atenção na funcionalidade stopPropagation responsavel por impedir do acordeon expadir ao clicar*/}
                <div onClick={async (e) => { e.stopPropagation(); }}>

                  <DropdownButtonExport
                    isLoading={isLoading}
                    onClick={(type: string) => {
                      let dDashCore: DatasetModel = DatasetDefault;
                      Object.assign(dDashCore, datasetDashboardCore);
                      dDashCore.data = [];
                      FileExportService.Export(
                        {
                          ...RequestInputOutputParamsModelDefault,
                          datasets: [dDashCore],
                        },
                        "Dashboard",
                        type
                      );
                    }}
                  />
                </div>

                {/* Botão informaçoes gerais - Atenção na funcionalidade stopPropagation responsavel por impedir do acordeon expadir ao clicar*/}
                <div onClick={async (e) => { e.stopPropagation(); }}>
                  <ButtonInfo
                    disabled={isLoading}
                    isLoading={isLoading}
                    onClick={showGeneralInformation}
                    titlePopOver={t("MODAL_GENERAL_INFORMATION.TITLE")}
                  />
                </div>


                {/* Botão Legendas - Atenção na funcionalidade stopPropagation responsavel por impedir do acordeon expadir ao clicar*/}
                <div onClick={async (e) => { e.stopPropagation(); }}>
                  <ButtonCaption
                    disabled={isLoading}
                    isLoading={isLoading}
                    onClick={showGeneralCaption}
                    titlePopOver={t("MODAL_GENERAL_CAPTION.TITLE")}
                  />
                </div>

              </div>
            </div>}

        </div>

      </Form>


      <div
        style={{
          display: "flex",
          justifyContent: "space-between", // Botão no canto esquerdo e navegação no centro
          alignItems: "center", // Alinha tudo verticalmente no centro
          height: "50px", // Altura fixa para garantir alinhamento
        }}
      >
        {/* Ícone de mais no canto esquerdo */}
        <div
          style={{
            display: "flex",
            alignItems: "center", // Centraliza verticalmente
          }}
        >
          {(!showClientGroup || !showBalanceGroup) && (
            <Button
              variant="link"
              onClick={() => {
                // Exibir ambos os grupos
                setShowClientGroup(true);
                setShowBalanceGroup(true);
              }}
              style={{
                textDecoration: "none",
                fontSize: "1.8rem", // Tamanho maior do ícone para melhor visibilidade
                color: "#004080", // Fundo azul escuro
                backgroundColor: "transparent", 
                width: "32px", // Aumentado para melhor proporção
                height: "32px", // Aumentado para melhor proporção
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                marginLeft: "14px",
              }}
            >
              <FontAwesomeIcon icon={faAnglesRight} />
            </Button>
          )}
        </div>

        {/* Navegação centralizada */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center", // Centraliza verticalmente
            flex: "1", // Preenche o espaço disponível no centro
          }}
        >
          <Button
            className="me-2"
            style={{
              backgroundColor: "#004080", // Azul do botão
              color: "#fff", // Texto branco
            }}
            disabled={isEqualTo8DaysAgo}
            onClick={() => {
              addDayToPeriod(-1);
            }}
          >
            {"<"}
          </Button>
          <span style={{ margin: "0 10px", fontSize: "1rem" }}>
            {renderPeriodDescription()}
          </span>
          <Button
            className="me-2"
            style={{
              backgroundColor: "#004080", // Azul do botão
              color: "#fff", // Texto branco
            }}
            disabled={isEqualToDay}
            onClick={() => {
              addDayToPeriod(1);
            }}
          >
            {">"}
          </Button>
        </div>
      </div>


      <Row>
        <Col sm={12}>
            <Table
              key={`cg:${showClientGroup}-bg:${showBalanceGroup}`}  // ✅ AQUI
              data={data}
              hideFilter={!hideFilter}
              columns={columns}
              update={fetchMoreData}
              total_records={datasetDashboardCore?.pagination?.total_records}
              msgEmpty={t("DASHBOARD.IS_NOT_UPDATED")}
              showClientGroup={showClientGroup}
              showBalanceGroup={showBalanceGroup}
            />
        </Col>
      </Row>

      <Row>
        <Col>
          {t("DATA_GRID.INFO_START")}&nbsp;1&nbsp;
          {t("DATA_GRID.INFO_TO")}&nbsp;
          {
            Math.min(
              datasetDashboardCore?.pagination?.page_number *
                datasetDashboardCore?.pagination?.records_pages,
              datasetDashboardCore?.pagination?.total_records || 0
            )
          }
          &nbsp;{t("DATA_GRID.INFO_TOTAL")}&nbsp;
          {datasetDashboardCore?.pagination?.total_records}&nbsp;
          {t("DATA_GRID.INFO_RECORDS")}
        </Col>        
        {/* <Col>
          {t("DATA_GRID.INFO_START")}&nbsp;1&nbsp;{t("DATA_GRID.INFO_TO")}&nbsp;{" "}
          {datasetDashboardCore?.pagination?.page_number *
            datasetDashboardCore?.pagination?.records_pages}{" "}
          &nbsp;{t("DATA_GRID.INFO_TOTAL")}&nbsp;
          {datasetDashboardCore?.pagination?.total_records}&nbsp;
          {t("DATA_GRID.INFO_RECORDS")}
        </Col> */}
        {cacheDate ? t("DATA_GRID.LAST_CACHE_UPDATE") : ""} {cacheDate}
      </Row>

    </>
  );
};
